<template>
    <div>
        <h2 class="mb-1">Active Treatment Report</h2>
        
        <div style="display: flex; flex-wrap: wrap; align-items: center;" class="mb-2">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-50"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="prevRange()"
            >
                <feather-icon icon="ChevronLeftIcon" />
            </b-button>

            <b-form-group
                label="Start Date"
                class="mr-50 w-10"
            >
                <date-picker v-model="startDate" type="month" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-if="selectedRangeDate === 'month' || selectedRangeDate === 'quarter'"></date-picker>
                <date-picker v-model="startDate" type="year" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="selectedRangeDate === 'year'"></date-picker>
                <date-picker v-model="startDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="!selectedRangeDate || selectedRangeDate === 'custom'"></date-picker>
            </b-form-group>

            <b-form-group
                label="End Date"
                class="mr-50"
            >
                <date-picker v-model="endDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" :disabled="selectedRangeDate === 'month' || selectedRangeDate === 'quarter' || selectedRangeDate === 'year' ? true : false"></date-picker>
            </b-form-group>

            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon ml-0"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="nextRange()"
            >
                <feather-icon icon="ChevronRightIcon" />
            </b-button>
                
            <div :class="!selectedRangeDate ? 'pl-1' : 'pl-1'">
                <b-form-group>
                    <b-form-radio-group
                        v-model="selectedRangeDate"
                        button-variant="outline-primary range-date"
                        buttons
                        class="p-0 mr-2"
                    >
                        <b-form-radio style="height: 37px; padding: 11px;" v-for="(option,index) in optionsRangeDate" :key="index" :value="option.value">{{option.text}}</b-form-radio>
                        <b-form-radio style="height: 37px; padding: 10px;" v-if="selectedRangeDate" value="x">x</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>

            <b-form-group
                label="Region"
            >
                <v-select
                    v-model="region"
                    placeholder="Region"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="optionsRegion"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <div v-if="region === 'NYC'">
                <b-form-group
                    label="Borough"
                >
                    <v-select
                        v-model="borough"
                        placeholder="Any Borough"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="optionsBorough"
                        style="background: #fff; min-width: 200px;"
                        class="mr-2"
                    />
                </b-form-group>
            </div>

            <b-form-group
                label="Program"
            >
                <b-form-select
                    v-model="clinicianProgram"
                    inline
                    :options="optionsProgram"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group
                label="New or Returning Client"
                class="ml-2"
            >
                <v-select
                    v-model="newOrReturningClient"
                    placeholder="New or Returning Client"
                    :options="optionsNewOrReturningClient"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Client Status"
            >
                <v-select
                    v-model="clientStatusAdmission"
                    placeholder="Client Status"
                    :options="optionsClientStatusAdmission"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Presenting Problems at Admission"
            >
                <v-select
                    v-model="presentingProblemsAtAdmission"
                    placeholder="Presenting Problems at Admission"
                    :options="optionsPresentingProblemsAtAdmission"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Diagnostic Criteria Met at Admission"
            >
                <v-select
                    v-model="diagnosticCriteriaMetAtAdmission"
                    placeholder="Diagnostic Criteria Met at Admission"
                    :options="optionsDiagnosticCriteriaMetAtAdmission"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Client Involved with Legal System"
            >
                <v-select
                    v-model="clientInvolvedWithLegalSystem"
                    placeholder="Client Involved with Legal System"
                    :options="optionsYesNoNA"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Client Release Signed"
            >
                <v-select
                    v-model="clientReleaseSigned"
                    placeholder="Client Release Signed"
                    :options="optionsYesNoNA"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Race"
            >
                <v-select
                    v-model="race"
                    placeholder="Race"
                    :options="optionsRace"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Hispanic Origin"
            >
                <v-select
                    v-model="ethnicity"
                    placeholder="Hispanic Origin"
                    :options="optionsEthnicity"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Asian Origin"
            >
                <v-select
                    v-model="asianOrigin"
                    placeholder="Asian Origin"
                    :options="optionsAsianOrigin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Pacific Islander Origin"
            >
                <v-select
                    v-model="pacificIslanderOrigin"
                    placeholder="Pacific Islander Origin"
                    :options="optionsPacificIslanderOrigin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Household Income"
            >
                <v-select
                    v-model="householdIncome"
                    placeholder="Household Income"
                    :options="optionsHouseholdIncome"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Types of Gambling Engaged In"
            >
                <v-select
                    v-model="gamblingTypes"
                    placeholder="Types of Gambling Engaged In"
                    :options="optionsGamblingTypes"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Employment Status"
            >
                <v-select
                    v-model="employmentStatus"
                    placeholder="Employment Status"
                    :options="optionsEmploymentStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Highest Grade Completed"
            >
                <v-select
                    v-model="educationLevels"
                    placeholder="Highest Grade Completed"
                    :options="optionsEducationLevels"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Veteran"
            >
                <v-select
                    v-model="veteran"
                    placeholder="Veteran"
                    :options="optionsYesNoNA"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Industry of employment"
            >
                <v-select
                    v-model="industryOfEmployment"
                    placeholder="Industry of employment"
                    :options="optionsIndustryOfEmployment"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Marital status"
            >
                <v-select
                    v-model="maritalStatus"
                    placeholder="Marital status"
                    :options="optionsMaritalStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Religious preference"
            >
                <v-select
                    v-model="religiousPreference"
                    placeholder="Religious preference"
                    :options="optionsReligiousPreference"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Primary ICD-10 Diagnosis Code"
            >
                <v-select
                    v-model="primaryICD10"
                    placeholder="Primary ICD-10 Diagnosis Code"
                    :options="optionsPrimaryICD10"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Age"
            >
                <v-select
                    v-model="age"
                    placeholder="Age"
                    :options="optionsAge"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Sexual Orientation"
            >
                <v-select
                    v-model="sexualOrientation"
                    placeholder="Sexual Orientation"
                    :options="optionsSexualOrientation"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Gender Identity"
            >
                <v-select
                    v-model="genderIdentity"
                    placeholder="Gender Identity"
                    :options="optionsGenderIdentity"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Transgender"
            >
                <v-select
                    v-model="transgender"
                    placeholder="Transgender"
                    :options="optionsTransgender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="How was client referred for services?"
            >
                <v-select
                    v-model="referredByAdmission"
                    placeholder="How was client referred for services?"
                    :options="optionsReferredBy"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="I. Disability/Developmental Disability"
            >
                <v-select
                    v-model="developmentalDisability"
                    placeholder="Intellectual Disability/Developmental Disability"
                    :options="optionsYesNoPreferNotToAnswer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Co-existing Psychiatric Disorder"
            >
                <v-select
                    v-model="coexistingPsychiatricDisorder"
                    placeholder="Co-existing Psychiatric Disorder"
                    :options="optionsYesNoPreferNotToAnswer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Treated for Mental Illness"
            >
                <v-select
                    v-model="treatedForMentalIllness"
                    placeholder="Treated for Mental Illness"
                    :options="optionsYesNoPreferNotToAnswer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Hospitalized for Mental Illness"
            >
                <v-select
                    v-model="hospitalizedForMentalIllness"
                    placeholder="Hospitalized for Mental Illness"
                    :options="optionsYesNoPreferNotToAnswer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="H. 30 or more days for MI"
            >
                <v-select
                    v-model="hospitalized30OrMoreDaysForMentalIllness"
                    placeholder="Hospitalized 30 or more days for Mental Illness"
                    :options="optionsYesNoPreferNotToAnswer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Smoked tobacco in the past week"
            >
                <v-select
                    v-model="smokedTobaccoInThePastWeek"
                    placeholder="Smoked tobacco in the past week"
                    :options="optionsYesNoPreferNotToAnswer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Used smok. tobacco in the past week"
            >
                <v-select
                    v-model="usedSmokelessTobaccoInThePastWeek"
                    placeholder="Used smokeless tobacco in the past week"
                    :options="optionsYesNoPreferNotToAnswer"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Substances Used"
            >
                <v-select
                    v-model="substancesUsed"
                    placeholder="Substances Used"
                    :options="optionsSubstancesUsed"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Substance Use Route of Admin."
            >
                <v-select
                    v-model="substanceUseRouteOfAdministration"
                    placeholder="Substance Use Route of Administration"
                    :options="optionsSubstanceUseRouteOfAdministration"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Frequency of Substance Use"
            >
                <v-select
                    v-model="frequencyOfSubstanceUse"
                    placeholder="Frequency of Substance Use"
                    :options="optionsFrequencyOfSubstanceUse"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Frequency of Gambling"
            >
                <v-select
                    v-model="frequencyofGambling"
                    placeholder="Frequency of Gambling"
                    :options="optionsFrequencyofGambling"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 250px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Gambling loc. during the past 12 months"
            >
                <v-select
                    v-model="gamblinglocationspast12months"
                    placeholder="Gambling locations during the past 12 months"
                    :options="optionsGamblinglocationspast12months"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 300px;"
                    class=" mr-2"
                />
            </b-form-group>

            <b-form-group
                label="Has client attended or rec. serv. for any reason from"
            >
                <v-select
                    v-model="hasClientAttendedReceivedServices"
                    placeholder="Has client attended or received services for any reason from"
                    :options="optionsHasClientAttendedReceivedServices"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    style="background: #fff; min-width: 300px;"
                    class=" mr-2"
                />
            </b-form-group>

            <div>
                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="mb-1 mt-2 p-75"
                    @click="activeFilterFunction"
                >
                    <feather-icon
                        icon="Xicon"
                        class="mr-50"
                    />
                    <span class="align-middle">Reset filters</span>
                </b-button>
            </div>
        <!-- </b-row> -->
        </div>

        <b-row>
            <!-- Total Clients In Treatment -->
            <b-col
                lg="4"
                md="4"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countTotalClientsInTreatment && countTotalClientsInTreatment !== 'NaN' ? countTotalClientsInTreatment.toLocaleString('en-US') : 0 }}
                        </h2>
                        <span>Total Clients In Treatment</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Total Gamblers In Treatment -->
            <b-col
                lg="4"
                md="4"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countTotalFamilyMembersInTreatment && countTotalFamilyMembersInTreatment !== 'NaN' ? countTotalFamilyMembersInTreatment.toLocaleString('en-US') : 0 }}
                        </h2>
                        <span>Total Family Members In Treatment</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Total Gamblers In Treatment -->
            <b-col
                lg="4"
                md="4"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countTotalGamblersInTreatment && countTotalGamblersInTreatment !== 'NaN' ? countTotalGamblersInTreatment.toLocaleString('en-US') : 0 }}
                        </h2>
                        <span>Total Gamblers In Treatment</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <!-- Other/Blank -->
            <b-col
                lg="6"
                md="6"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countOtherBlank && countOtherBlank !== 'NaN' ? countOtherBlank.toLocaleString('en-US') : 0 }}
                        </h2>
                        <span>Other/Blank In Treatment</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="6"
                md="6"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="loadTotalClients">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ totalNonEnglishClients && totalNonEnglishClients !== 'NaN' ? totalNonEnglishClients.toLocaleString('en-US') : 0 }}
                        </h2>
                        <span>Total Non-English Clients</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>

        <b-row>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countReturningClient && countReturningClient !== 'NaN' ? countReturningClient.toFixed(0) : 0 }}
                        </h2>
                        <span>Returning Client</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countNewClient && countNewClient !== 'NaN' ? countNewClient.toFixed(0) : 0 }}
                        </h2>
                        <span>New Client</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAACOMHD && countPPAACOMHD !== 'NaN' ? countPPAACOMHD.toFixed(0) : 0 }}
                        </h2>
                        <span>Co-occurring mental health disorders</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAACOSUD && countPPAACOSUD !== 'NaN' ? countPPAACOSUD.toFixed(0) : 0 }}
                        </h2>
                        <span>Co-occurring substance use disorders</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAAED && countPPAAED !== 'NaN' ? countPPAAED.toFixed(0) : 0 }}
                        </h2>
                        <span>Employment difficulties</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAAFD && countPPAAFD !== 'NaN' ? countPPAAFD.toFixed(0) : 0 }}
                        </h2>
                        <span>Financial difficulties</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAAPHP && countPPAAPHP !== 'NaN' ? countPPAAPHP.toFixed(0) : 0 }}
                        </h2>
                        <span>Physical health problems</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAARD && countPPAARD !== 'NaN' ? countPPAARD.toFixed(0) : 0 }}
                        </h2>
                        <span>Relationship difficulties</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAAED && countPPAAED !== 'NaN' ? countPPAAED.toFixed(0) : 0 }}
                        </h2>
                        <span>Education difficulties</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAAMD && countPPAAMD !== 'NaN' ? countPPAAMD.toFixed(0) : 0 }}
                        </h2>
                        <span>Marital difficultiess</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAAB && countPPAAB !== 'NaN' ? countPPAAB.toFixed(0) : 0 }}
                        </h2>
                        <span>Bankruptcy</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAABOTFFF && countPPAABOTFFF !== 'NaN' ? countPPAABOTFFF.toFixed(0) : 0 }}
                        </h2>
                        <span>Borrowing or theft from family/friends</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAALSR && countPPAALSR !== 'NaN' ? countPPAALSR.toFixed(0) : 0 }}
                        </h2>
                        <span>Losing savings/retirement</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAASD && countPPAASD !== 'NaN' ? countPPAASD.toFixed(0) : 0 }}
                        </h2>
                        <span>Significant debt</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAAE && countPPAAE !== 'NaN' ? countPPAAE.toFixed(0) : 0 }}
                        </h2>
                        <span>Embezzlement</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAASITA && countPPAASITA !== 'NaN' ? countPPAASITA.toFixed(0) : 0 }}
                        </h2>
                        <span>Suicidal Ideation/Thoughts/Attempts</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAALI && countPPAALI !== 'NaN' ? countPPAALI.toFixed(0) : 0 }}
                        </h2>
                        <span>Legal Issues</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAAA && countPPAAA !== 'NaN' ? countPPAAA.toFixed(0) : 0 }}
                        </h2>
                        <span>Arrest</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAAINCA && countPPAAINCA !== 'NaN' ? countPPAAINCA.toFixed(0) : 0 }}
                        </h2>
                        <span>Incarceration</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countPPAANA && countPPAANA !== 'NaN' ? countPPAANA.toFixed(0) : 0 }}
                        </h2>
                        <span>Presenting Problems at Admission/N/A</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAANA && countDCMAANA !== 'NaN' ? countDCMAANA.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/N/A</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAAALMGOR && countDCMAAALMGOR !== 'NaN' ? countDCMAAALMGOR.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/After losing money gambling, often returns another day to get even ("chasing" ones losses)</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAAHJLASR && countDCMAAHJLASR !== 'NaN' ? countDCMAAHJLASR.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/Has jeopardized or lost a significant relationship, job, or educational or career opportunity because of gambling.</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAAHMRUETC && countDCMAAHMRUETC !== 'NaN' ? countDCMAAHMRUETC.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/Has made repeated unsuccesful efforts to control, cut back, or stop gambling</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAAIOPW && countDCMAAIOPW !== 'NaN' ? countDCMAAIOPW.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/Is often preoccupied with (e.g., having persistent thoughts of reliving past gambling experiences, handicapping or planning the next venture, thinking of ways to get money with which to gamble).</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAAIROIWA && countDCMAAIROIWA !== 'NaN' ? countDCMAAIROIWA.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/Is restless or irritable when attempting to cut down or stop gambling.</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAALTCTE && countDCMAALTCTE !== 'NaN' ? countDCMAALTCTE.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/Lies to conceal the extent of involvement with gambling.</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAAOGWFD && countDCMAAOGWFD !== 'NaN' ? countDCMAAOGWFD.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/Often gambles when feeling distressed (e.g., helpless, guilty, anxious, depressed).</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAANTGWI && countDCMAANTGWI !== 'NaN' ? countDCMAANTGWI.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/Needs to gamble with increasing amounts of money in order to achieve the desired excitement.</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countDCMAAROOTPM && countDCMAAROOTPM !== 'NaN' ? countDCMAAROOTPM.toFixed(0) : 0 }}
                        </h2>
                        <span>Diagnostic Criteria Met at Admission/Relies on others to provide money to relieve desperate financial situations caused by gambling.</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countCIWLSYES && countCIWLSYES !== 'NaN' ? countCIWLSYES.toFixed(0) : 0 }}
                        </h2>
                        <span>Client Involved with Legal System/Yes</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countCIWLSNO && countCIWLSNO !== 'NaN' ? countCIWLSNO.toFixed(0) : 0 }}
                        </h2>
                        <span>Client Involved with Legal System/No</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countCIWLSNA && countCIWLSNA !== 'NaN' ? countCIWLSNA.toFixed(0) : 0 }}
                        </h2>
                        <span>Client Involved with Legal System/N/A</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countCRSYES && countCRSYES !== 'NaN' ? countCRSYES.toFixed(0) : 0 }}
                        </h2>
                        <span>Client Release Signed/Yes</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countCRSNO && countCRSNO !== 'NaN' ? countCRSNO.toFixed(0) : 0 }}
                        </h2>
                        <span>Client Release Signed/No</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countCRSNA && countCRSNA !== 'NaN' ? countCRSNA.toFixed(0) : 0 }}
                        </h2>
                        <span>Client Release Signed/N/A</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countRaceAN && countRaceAN !== 'NaN' ? countRaceAN.toFixed(0) : 0 }}
                        </h2>
                        <span>Race/Alaskan Native</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countRaceAs && countRaceAs !== 'NaN' ? countRaceAs.toFixed(0) : 0 }}
                        </h2>
                        <span>Race/Asian</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countRaceBOAA && countRaceBOAA !== 'NaN' ? countRaceBOAA.toFixed(0) : 0 }}
                        </h2>
                        <span>Race/Black or African American</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countRaceHOOOPI && countRaceHOOOPI !== 'NaN' ? countRaceHOOOPI.toFixed(0) : 0 }}
                        </h2>
                        <span>Race/Hawaiian or other Pacific Islander</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countRaceMEONA && countRaceMEONA !== 'NaN' ? countRaceMEONA.toFixed(0) : 0 }}
                        </h2>
                        <span>Race/Middle Eastern or North African</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countRaceNAIOAI && countRaceNAIOAI !== 'NaN' ? countRaceNAIOAI.toFixed(0) : 0 }}
                        </h2>
                        <span>Race/Native American, Indigenous, or American Indian</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countRaceWH && countRaceWH !== 'NaN' ? countRaceWH.toFixed(0) : 0 }}
                        </h2>
                        <span>Race/White</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countRaceSOREO && countRaceSOREO !== 'NaN' ? countRaceSOREO.toFixed(0) : 0 }}
                        </h2>
                        <span>Race/Some other race, ethnicity, origin</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countRacePNTA && countRacePNTA !== 'NaN' ? countRacePNTA.toFixed(0) : 0 }}
                        </h2>
                        <span>Race/Prefer not to answer</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countEthnicityCUB && countEthnicityCUB !== 'NaN' ? countEthnicityCUB.toFixed(0) : 0 }}
                        </h2>
                        <span>Hispanic Origin/Cuban</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countEthnicityMEX && countEthnicityMEX !== 'NaN' ? countEthnicityMEX.toFixed(0) : 0 }}
                        </h2>
                        <span>Hispanic Origin/Mexican</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countEthnicityPR && countEthnicityPR !== 'NaN' ? countEthnicityPR.toFixed(0) : 0 }}
                        </h2>
                        <span>Hispanic Origin/Puerto Rican</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countEthnicityHLNS && countEthnicityHLNS !== 'NaN' ? countEthnicityHLNS.toFixed(0) : 0 }}
                        </h2>
                        <span>Hispanic Origin/Hispanic/Latino/a/x, Not Specified</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countEthnicityNOTH && countEthnicityNOTH !== 'NaN' ? countEthnicityNOTH.toFixed(0) : 0 }}
                        </h2>
                        <span>Hispanic Origin/Not of Hispanic Origin</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countEthnicityPNTA && countEthnicityPNTA !== 'NaN' ? countEthnicityPNTA.toFixed(0) : 0 }}
                        </h2>
                        <span>Hispanic Origin/Prefer not to answer</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianAIN && countAsianAIN !== 'NaN' ? countAsianAIN.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Asian Indian</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianBANG && countAsianBANG !== 'NaN' ? countAsianBANG.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Bangladeshi</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianBURM && countAsianBURM !== 'NaN' ? countAsianBURM.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Burmese</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianCAMB && countAsianCAMB !== 'NaN' ? countAsianCAMB.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Cambodian</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianCHIN && countAsianCHIN !== 'NaN' ? countAsianCHIN.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Chinese</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianFIL && countAsianFIL !== 'NaN' ? countAsianFIL.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Filipino</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianHMONG && countAsianHMONG !== 'NaN' ? countAsianHMONG.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Hmong</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianINDO && countAsianINDO !== 'NaN' ? countAsianINDO.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Indonesian</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianJAP && countAsianJAP !== 'NaN' ? countAsianJAP.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Japanese</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianKOR && countAsianKOR !== 'NaN' ? countAsianKOR.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Korean</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianLAOT && countAsianLAOT !== 'NaN' ? countAsianLAOT.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Laotian</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianMALA && countAsianMALA !== 'NaN' ? countAsianMALA.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Malaysian</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianNEPA && countAsianNEPA !== 'NaN' ? countAsianNEPA.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Nepalese</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianPAKI && countAsianPAKI !== 'NaN' ? countAsianPAKI.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Pakistani</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianSRI && countAsianSRI !== 'NaN' ? countAsianSRI.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Sri Lankan</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianTAIW && countAsianTAIW !== 'NaN' ? countAsianTAIW.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Taiwanese</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianTHAI && countAsianTHAI !== 'NaN' ? countAsianTHAI.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Thai</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianTIB && countAsianTIB !== 'NaN' ? countAsianTIB.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Tibetan</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianVIET && countAsianVIET !== 'NaN' ? countAsianVIET.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Vietnamese</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianNSPE && countAsianNSPE !== 'NaN' ? countAsianNSPE.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Asian, Not Specified</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianNAORI && countAsianNAORI !== 'NaN' ? countAsianNAORI.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Not of Asian Origin</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ countAsianPNTA && countAsianPNTA !== 'NaN' ? countAsianPNTA.toFixed(0) : 0 }}
                        </h2>
                        <span>Asian Origin/Prefer not to answer</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <!-- Pacific Islander Origin -->
            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optPacificIslanderOrigin"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optHouseholdIncome"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optGamblingTypes"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optEmploymentStatus"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optEducationLevels"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optVeteran"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optIndustryOfEmployment"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optMaritalStatus"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optReligiousPreference"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optPrimaryICD10"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optAge"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optSexualOrientation"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optGenderIdentity"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optTransgender"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optReferredBy"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optIDisabilityDevelopmentalDisability"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optPsychiatricDisorder"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optMentalIllness"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optHospitalizedforMentalIllness"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optHospitalized30ormoredays"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optSmokedtobacco"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optUsedsmokelesstobacco"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optSubstancesUsed"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optSubstanceUseRouteOfAdministration"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optFrequencyOfSubstanceUse"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optFrequencyofGambling"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optGamblinglocationspast12months"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col
                lg="3"
                md="3"
                sm="12"
                v-for="(item, index) in optHasClientAttendedReceivedServices"
                :key="item.name+index"
            >
                <b-card no-body>
                    <b-card-body class="d-flex justify-content-between align-items-center">
                    <div class="truncate">
                        <div class="text-primary" v-if="isBusy">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                        <h2 class="mb-25 font-weight-bolder" v-else>
                        {{ item.count && item.count !== 'NaN' ? item.count.toFixed(0) : 0 }}
                        </h2>
                        <span>{{item.name}}</span>
                    </div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>

        <download-csv 
            :data="json_data"
            class="mb-1 btn btn-default"
            name="reports-active-treatment.csv"
            :style="readyToExport ? 'background: #94221e; color: #fff; cursor: pointer; opacity: 1;' : 'background: #94221e; color: #fff; cursor: no-drop; opacity: 0.5;'"
            delimiter=","
            v-if="isDataSpecialist"
        >
            CSV Export
            <b-spinner small v-if="!readyToExport" />
        </download-csv>
    </div>
</template>

<script>
import { 
    BForm, BButton, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BTable, BFormInvalidFeedback, BFormSelect, BCard, BAvatar, BCardBody,
    BSpinner, BFormRadioGroup, BFormRadio,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { db, auth } from '@/firebase'

export default {
    data() {
        return {
            // validation
            required,
            email,
            totalRows: 0,
            isDataSpecialist: false,
            readyToExport: false,

            // filters
            startDate: null,
            endDate: null,
            selectedRangeDate: 'month',
            optionsRangeDate: [
                { text: 'Month', value: 'month' },
                { text: 'Quarter', value: 'quarter' },
                { text: 'Year', value: 'year' },
                { text: 'Custom', value: 'custom' },
            ],
            region: '',
            borough: '',
            language: '',
            progress: '',
            insurance: '',

            // data report
            countTotalClientsInTreatment: 0,
            countTotalFamilyMembersInTreatment: 0,
            countTotalGamblersInTreatment: 0,
            averageTreatmentSessionsCompleted: 0,
            averageLengthOfStay: 0,
            totalNonEnglishClients: 0,
            countOtherBlank: 0,

            // options
            optionsRegion: [],
            optionsBorough: [
                'Bronx',
                'Brooklyn',
                'Manhattan',
                'Queens',
                'Staten Island'
            ],
            // optionsRegion: [
            //     'Bronx',
            //     'Brooklyn',
            //     'Central',
            //     'Finger Lakes',
            //     'Long Island',
            //     'Manhattan',
            //     'Mid-Hudson',
            //     'Northeast',
            //     'Queens',
            //     'Staten Island',
            //     'Western'
            // ],
            optionsLanguage: [],
            optionsClientProgress: [
                'Any Client Status',
                'Engaged',
                'Closed - Attended First Session',
                'Closed - Did not attend first session',
                'Closed - Received information',
                'Closed - Referred to OASAS Program',
                'External Referral',
                'On Hold'
            ],
            optionsInsurance: [],

            // settings table and edit view
            statusEdit: false,
            itemsActivity: [],
            fieldsTable: [
                { key: 'clientID', sortable: false },
                { key: 'clientName', sortable: false },
                { key: 'status', sortable: false },
                { key: 'contactDate', sortable: false },
                { key: 'admissionDate', sortable: false },
                { key: 'dischargeDate', sortable: false },
                // { key: 'actions', sortable: false },
            ],
            clinicianProgram: null,
            optionsProgram: [],

            // get data from db
            optionsClient: [],
            optionsClinician: [],

            // json to export csv
            json_data: [],

            // filter
            clientActivityName: null,
            clientActivityStatus: null,

            // reports cards
            totalGroupSessions: 0,
            totalIndividualSessions: 0,
            totalRemoteSessions: 0,
            // totalNonEnglishClients: 0,
            clientSatisfaction: 0,
            improved: 0,

            // overlay data
            rangeDinamic: false,
            isBusy: true,
            loadTotalClients: true,

            // new vars filter
            newOrReturningClient: '',
            clientStatusAdmission: '',
            presentingProblemsAtAdmission: '',
            diagnosticCriteriaMetAtAdmission: '',
            clientInvolvedWithLegalSystem: '',
            clientReleaseSigned: '',
            race: '',
            ethnicity: '',
            asianOrigin: '',
            pacificIslanderOrigin: '',
            householdIncome: '',
            gamblingTypes: '',
            employmentStatus: '',
            educationLevels: '',
            veteran: '',
            industryOfEmployment: '',
            maritalStatus: '',
            religiousPreference: '',
            primaryICD10: '',
            age: '',
            sexualOrientation: '',
            genderIdentity: '',
            transgender: '',
            referredByAdmission: '',
            developmentalDisability: '',
            coexistingPsychiatricDisorder: '',
            treatedForMentalIllness: '',
            hospitalizedForMentalIllness: '',
            hospitalized30OrMoreDaysForMentalIllness: '',
            smokedTobaccoInThePastWeek: '',
            usedSmokelessTobaccoInThePastWeek: '',
            substancesUsed: '',
            substanceUseRouteOfAdministration: '',
            frequencyOfSubstanceUse: '',
            frequencyofGambling: '',
            gamblinglocationspast12months: '',
            hasClientAttendedReceivedServices: '',

            // options
            optionsNewOrReturningClient: [
                'Returning Client',
                'New Client',
                'N/A'
            ],
            optionsClientStatusAdmission: [
                'Problem Gambler',
                'Family Member'
            ],
            optionsPresentingProblemsAtAdmission: [
                'Co-occurring mental health disorders',
                'Co-occurring substance use disorders',
                'Employment difficulties',
                'Financial difficulties',
                'Physical health problems',
                'Relationship difficulties',
                'Education difficulties',
                'Marital difficulties',
                'Bankruptcy',
                'Borrowing or theft from family/friends',
                'Losing savings/retirement',
                'Significant debt',
                'Embezzlement',
                'Suicidal Ideation/Thoughts/Attempts',
                'Legal Issues',
                'Arrest',
                'Incarceration',
                'N/A'
            ],
            optionsDiagnosticCriteriaMetAtAdmission: [
                'N/A',
                'After losing money gambling, often returns another day to get even ("chasing" ones losses)',
                'Has jeopardized or lost a significant relationship, job, or educational or career opportunity because of gambling.',
                'Has made repeated unsuccesful efforts to control, cut back, or stop gambling',
                'Is often preoccupied with (e.g., having persistent thoughts of reliving past gambling experiences, handicapping or planning the next venture, thinking of ways to get money with which to gamble).',
                'Is restless or irritable when attempting to cut down or stop gambling.',
                'Lies to conceal the extent of involvement with gambling.',
                'Often gambles when feeling distressed (e.g., helpless, guilty, anxious, depressed).',
                'Needs to gamble with increasing amounts of money in order to achieve the desired excitement.',
                'Relies on others to provide money to relieve desperate financial situations caused by gambling.'
            ],
            optionsYesNoNA: ['Yes', 'No', 'N/A'],
            optionsRace: [],
            optionsEthnicity: [
                'Cuban',
                'Mexican',
                'Puerto Rican',
                'Hispanic/Latino/a/x, Not Specified',
                'Not of Hispanic Origin',
                'Prefer not to answer'
            ],
            optionsAsianOrigin: [
                'Asian Indian',
                'Bangladeshi',
                'Burmese',
                'Cambodian',
                'Chinese',
                'Filipino',
                'Hmong',
                'Indonesian',
                'Japanese',
                'Korean',
                'Laotian',
                'Malaysian',
                'Nepalese',
                'Pakistani',
                'Sri Lankan',
                'Taiwanese',
                'Thai',
                'Tibetan',
                'Vietnamese',
                'Asian, Not Specified',
                'Not of Asian Origin',
                'Prefer not to answer'
            ],
            optionsPacificIslanderOrigin: [
                'Fijian',
                'Guamanian',
                'Hawaiian',
                'Samoan',
                'Tongan',
                'Pacific Islander, Not Specified',
                'Not of Pacific Islander Origin',
                'Prefer not to answer'
            ],
            optionsHouseholdIncome: [],
            optionsGamblingTypes: [],
            optionsEmploymentStatus: [],
            optionsEducationLevels: [],
            optionsIndustryOfEmployment: [
                'Business',
                'Computer',
                'Telecommunications',
                'Financial Services',
                'Manufacturing',
                'Wholesale/Retail/Distribution',
                'Transportation',
                'Travel/Hospitality',
                'Government',
                'Military',
                'Aerospace',
                'Health Care/Medical',
                'Insurance/Legal',
                'Education',
                'Utilities',
                'Architecture/Construction/Real Estate',
                'Agriculture',
                'Religious',
                'Social Services',
                'Sales',
                'Gambling Industry',
                'None',
                'N/A'
            ],
            optionsMaritalStatus: [
                'Married',
                'Never married',
                'Living as married',
                'Separated',
                'Divorced',
                'Widowed',
                'N/A'
            ],
            optionsReligiousPreference: [
                'Catholic',
                'Protestant',
                'Other Christian',
                'Jewish',
                'Muslim',
                'Buddhist',
                'Atheist/Agnostic',
                'No preference',
                'Other',
                'N/A'
            ],
            optionsPrimaryICD10: [
                'F 63.0 Pathological Gambling',
                'Z72.6 Gambling and Betting'
            ],
            optionsAge: [
                'Under 18',
                '18 - 24',
                '25 - 34',
                '35 - 44',
                '45 - 54',
                '55 - 64',
                '65+',
                'Prefer not to answer'
            ],
            optionsSexualOrientation: [
                'Bisexual',
                'Lesbian or Gay',
                'Pansexual',
                'Straight',
                'I use a different term',
                'Questioning/Unsure',
                'Prefer not to answer'
            ],
            optionsGenderIdentity: [
                'Intersex',
                'Man',
                'Non-Binary',
                'Two-Spirit',
                'Woman',
                'I use a different term',
                'Questioning/Unsure',
                'Prefer not to answer'
            ],
            optionsTransgender: [
                'Yes',
                'No',
                'Questioning/Unsure',
                'Prefer not to answer'
            ],
            optionsReferredBy: [
                'HOPEline',
                'Family member/Self',
                'Friends or Other Individual',
                'Problem Gambling Self-Help Group Meetings',
                'Substance Use Self-Help Group Meetings',
                'Financial Counseling',
                'Crisis Services',
                'Problem Gambling Treatment Services',
                'Substance Use Treatment Services',
                'Recovery Support Services',
                'Other'
            ],
            optionsYesNoPreferNotToAnswer: [
                'No',
                'Yes',
                'Prefer not to answer'
            ],
            optionsSubstancesUsed: [
                'None',
                'Prefer not to answer',
                'Alcohol',
                'Cocaine',
                'Crack',
                'Marijuana/Hashish',
                'Heroin',
                'Buprenorphine',
                'Non-Rx Methadone',
                'OxyContin',
                'Other Opiate/Synthetic',
                'Alprazolam (Xanax)',
                'Barbiturate',
                'Benzodiazepine (Klonopin)',
                'Catapres (Clonidine)',
                'Other Sedative/Hypnotic',
                'Elavil',
                'GHB',
                'Khat',
                'Other Tranquilizer',
                'Methamphetamine',
                'Other Amphetamine',
                'Other Stimulant',
                'PCP',
                'Ecstasy',
                'Other Hallucinogen',
                'Ephedrine',
                'Inhalant',
                'Ketamine',
                'Rohypnol',
                'Over the counter',
                'Other'
            ],
            optionsSubstanceUseRouteOfAdministration: [
                'N/A',
                'Prefer not to answer',
                'Inhalation',
                'Injection',
                'Oral',
                'Smoking',
                'Vaping',
                'Other'
            ],
            optionsFrequencyOfSubstanceUse: [
                'N/A',
                'Prefer not to answer',
                'No use in past 30 days',
                '1 - 3 times in the past 30 days',
                '1 - 2 times per week',
                '3 - 6 times per week',
                'Daily'
            ],
            optionsFrequencyofGambling: [
                'None in the last 30 days',
                '1 - 3 times in the last 30 days',
                '1 - 2 times per week',
                '3 - 6 times per week',
                'Daily',
                'Prefer not to answer'
            ],
            optionsGamblinglocationspast12months: [
                'None',
                'Casino',
                'Race track',
                'Grocery/Convenience Store',
                'Internet',
                'Off-Track Betting (OTB)',
                'Bookie',
                'Bar/Restaurant',
                'Work',
                'School',
                'Home',
                'Church',
                'Community Site',
                'Other',
                'Prefer not to answer'
            ],
            optionsHasClientAttendedReceivedServices: [
                'Self-Help',
                'Other Gambling Program',
                'Financial and/or Credit Counseling Service',
                'N/A',
                'Prefer not to answer'
            ],

            // NEW COUNTERS
            countPPAACOMHD: 0,
            countPPAACOSUD: 0,
            countPPAAED: 0,
            countPPAAFD: 0,
            countPPAAPHP: 0,
            countPPAARD: 0,
            countPPAAED: 0,
            countPPAAMD: 0,
            countPPAAB: 0,
            countPPAABOTFFF: 0,
            countPPAALSR: 0,
            countPPAASD: 0,
            countPPAAE: 0,
            countPPAASITA: 0,
            countPPAALI: 0,
            countPPAAA: 0,
            countPPAAINCA: 0,
            countPPAANA: 0,
            countDCMAANA: 0,
            countDCMAAALMGOR: 0,
            countDCMAAHJLASR: 0,
            countDCMAAHMRUETC: 0,
            countDCMAAIOPW: 0,
            countDCMAAIROIWA: 0,
            countDCMAALTCTE: 0,
            countDCMAAOGWFD: 0,
            countDCMAANTGWI: 0,
            countDCMAAROOTPM: 0,
            countCIWLSYES: 0,
            countCIWLSNO: 0,
            countCIWLSNA: 0,
            countCRSYES: 0,
            countCRSNO: 0,
            countCRSNA: 0,
            countRaceAN: 0,
            countRaceAs: 0,
            countRaceBOAA: 0,
            countRaceHOOOPI: 0,
            countRaceMEONA: 0,
            countRaceNAIOAI: 0,
            countRaceWH: 0,
            countRaceSOREO: 0,
            countRacePNTA: 0,
            countEthnicityCUB: 0,
            countEthnicityMEX: 0,
            countEthnicityPR: 0,
            countEthnicityHLNS: 0,
            countEthnicityNOTH: 0,
            countEthnicityPNTA: 0,
            countAsianAIN: 0,
            countAsianBANG: 0,
            countAsianBURM: 0,
            countAsianCAMB: 0,
            countAsianCHIN: 0,
            countAsianFIL: 0,
            countAsianHMONG: 0,
            countAsianINDO: 0,
            countAsianJAP: 0,
            countAsianKOR: 0,
            countAsianLAOT: 0,
            countAsianMALA: 0,
            countAsianNEPA: 0,
            countAsianPAKI: 0,
            countAsianSRI: 0,
            countAsianTAIW: 0,
            countAsianTHAI: 0,
            countAsianTIB: 0,
            countAsianVIET: 0,
            countAsianNSPE: 0,
            countAsianNAORI: 0,
            countAsianPNTA: 0,
            
            optPacificIslanderOrigin: [
                {name: 'Pacific Islander Origin/Fijian', text: 'Fijian', count: 0},
                {name: 'Pacific Islander Origin/Guamanian', text: 'Guamanian', count: 0},
                {name: 'Pacific Islander Origin/Hawaiian', text: 'Hawaiian', count: 0},
                {name: 'Pacific Islander Origin/Samoan', text: 'Samoan', count: 0},
                {name: 'Pacific Islander Origin/Tongan', text: 'Tongan', count: 0},
                {name: 'Pacific Islander Origin/Pacific Islander, Not Specified', text: 'Pacific Islander, Not Specified', count: 0},
                {name: 'Pacific Islander Origin/Not of Pacific Islander Origin', text: 'Not of Pacific Islander Origin', count: 0},
                {name: 'Pacific Islander Origin/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optHouseholdIncome: [
                {name: 'Household Income/$15,000 - $30,000', text: '$15,000 - $30,000', count: 0},
                {name: 'Household Income/$30,001 - $50,000', text: '$30,001 - $50,000', count: 0},
                {name: 'Household Income/$50,001 - $75,000', text: '$50,001 - $75,000', count: 0},
                {name: 'Household Income/$75,001 - $100,000', text: '$75,001 - $100,000', count: 0},
                {name: 'Household Income/Less than $15,000', text: 'Less than $15,000', count: 0},
                {name: 'Household Income/More than $100,000', text: 'More than $100,000', count: 0},
                {name: 'Household Income/N/A', text: 'N/A', count: 0},
            ],
            optGamblingTypes: [
                {name: 'Types of Gambling Engaged In/None', text: 'None', count: 0},
                {name: 'Types of Gambling Engaged In/Office pools', text: 'Office pools', count: 0},
                {name: 'Types of Gambling Engaged In/Roulette', text: 'Roulette', count: 0},
                {name: 'Types of Gambling Engaged In/Slot machines', text: 'Slot machines', count: 0},
                {name: 'Types of Gambling Engaged In/Sports', text: 'Sports', count: 0},
                {name: 'Types of Gambling Engaged In/Stock/commodities market', text: 'Stock/commodities market', count: 0},
                {name: 'Types of Gambling Engaged In/Video lottery terminal (VLT)', text: 'Video lottery terminal (VLT)', count: 0},
                {name: 'Types of Gambling Engaged In/Dice games/coin flips', text: 'Dice games/coin flips', count: 0},
                {name: 'Types of Gambling Engaged In/Lottery (Numbers, Scratch offs, Quick Draw)', text: 'Lottery (Numbers, Scratch offs, Quick Draw)', count: 0},
                {name: 'Types of Gambling Engaged In/Game of skill for money (video games, bowling, pool, etc)', text: 'Game of skill for money (video games, bowling, pool, etc)', count: 0},
                {name: 'Types of Gambling Engaged In/Raffles (including 50/50 or pull tabs)', text: 'Raffles (including 50/50 or pull tabs)', count: 0},
                {name: 'Types of Gambling Engaged In/Native American (Turning Stone, Seneca, Ankwesasne, etc)', text: 'Native American (Turning Stone, Seneca, Ankwesasne, etc)', count: 0},
                {name: 'Types of Gambling Engaged In/Gambling on the internet (eGaming)', text: 'Gambling on the internet (eGaming)', count: 0},
                {name: 'Types of Gambling Engaged In/Commercial casinos (Tioga, Del Lago, Resorts World Catskills, Rivers, etc)', text: 'Commercial casinos (Tioga, Del Lago, Resorts World Catskills, Rivers, etc)', count: 0},
                {name: 'Types of Gambling Engaged In/Sports betting at a casino', text: 'Sports betting at a casino', count: 0},
                {name: 'Types of Gambling Engaged In/Mobile sports betting', text: 'Mobile sports betting', count: 0},
                {name: 'Types of Gambling Engaged In/Prefer not to answer', text: 'Prefer not to answer', count: 0},
                {name: 'Types of Gambling Engaged In/Bingo', text: 'Bingo', count: 0},
                {name: 'Types of Gambling Engaged In/Cards', text: 'Cards', count: 0},
                {name: 'Types of Gambling Engaged In/Horses', text: 'Horses', count: 0},
                {name: 'Types of Gambling Engaged In/Dogs/other animal', text: 'Dogs/other animal', count: 0},
            ],
            optEmploymentStatus: [
                {name: 'Employment Status/Employed Full Time – 35 hours or more/week', text: 'Employed Full Time – 35 hours or more/week', count: 0},
                {name: 'Employment Status/Employed Part Time – less than 35 hours/week', text: 'Employed Part Time – less than 35 hours/week', count: 0},
                {name: 'Employment Status/Unemployed, looking for work', text: 'Unemployed, looking for work', count: 0},
                {name: 'Employment Status/Unemployed, not looking for work', text: 'Unemployed, not looking for work', count: 0},
                {name: 'Employment Status/Not in Labor Force, Retired', text: 'Not in Labor Force, Retired', count: 0},
                {name: 'Employment Status/Not in Labor Force, Disabled', text: 'Not in Labor Force, Disabled', count: 0},
                {name: 'Employment Status/Not in Labor Force, Student', text: 'Not in Labor Force, Student', count: 0},
                {name: 'Employment Status/Not in Labor Force, Other', text: 'Not in Labor Force, Other', count: 0},
                {name: 'Employment Status/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optEducationLevels: [
                {name: 'Highest Grade Completed/No Education', text: 'No Education', count: 0},
                {name: 'Highest Grade Completed/1st grade', text: '1st grade', count: 0},
                {name: 'Highest Grade Completed/2st grade', text: '2st grade', count: 0},
                {name: 'Highest Grade Completed/3st grade', text: '3st grade', count: 0},
                {name: 'Highest Grade Completed/4st grade', text: '4st grade', count: 0},
                {name: 'Highest Grade Completed/5st grade', text: '5st grade', count: 0},
                {name: 'Highest Grade Completed/6st grade', text: '6st grade', count: 0},
                {name: 'Highest Grade Completed/7st grade', text: '7st grade', count: 0},
                {name: 'Highest Grade Completed/8st grade', text: '8st grade', count: 0},
                {name: 'Highest Grade Completed/9st grade', text: '9st grade', count: 0},
                {name: 'Highest Grade Completed/10st grade', text: '10st grade', count: 0},
                {name: 'Highest Grade Completed/11st grade', text: '11st grade', count: 0},
                {name: 'Highest Grade Completed/High school Diploma', text: 'High school Diploma', count: 0},
                {name: 'Highest Grade Completed/General Equivalency Diploma (GED)', text: 'General Equivalency Diploma (GED)', count: 0},
                {name: 'Highest Grade Completed/Vocational Certificate w/out Diploma/GED', text: 'Vocational Certificate w/out Diploma/GED', count: 0},
                {name: 'Highest Grade Completed/Vocational Certificate w/ Diploma/GED', text: 'Vocational Certificate w/ Diploma/GED', count: 0},
                {name: 'Highest Grade Completed/Some College – No Degree', text: 'Some College – No Degree', count: 0},
                {name: 'Highest Grade Completed/Associate’s Degree', text: 'Associate’s Degree', count: 0},
                {name: 'Highest Grade Completed/Bachelor’s Degree', text: 'Bachelor’s Degree', count: 0},
                {name: 'Highest Grade Completed/Graduate Degree', text: 'Graduate Degree', count: 0},
                {name: 'Highest Grade Completed/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optVeteran: [
                {name: 'Veteran/Yes', text: 'Yes', count: 0},
                {name: 'Veteran/No', text: 'No', count: 0},
                {name: 'Veteran/N/A', text: 'N/A', count: 0},
            ],
            optIndustryOfEmployment: [
                {name: 'Industry of employment/Business', text: 'Business', count: 0},
                {name: 'Industry of employment/Computer', text: 'Computer', count: 0},
                {name: 'Industry of employment/Telecommunications', text: 'Telecommunications', count: 0},
                {name: 'Industry of employment/Financial Services', text: 'Financial Services', count: 0},
                {name: 'Industry of employment/Manufacturing', text: 'Manufacturing', count: 0},
                {name: 'Industry of employment/Wholesale/Retail/Distribution', text: 'Wholesale/Retail/Distribution', count: 0},
                {name: 'Industry of employment/Transportation', text: 'Transportation', count: 0},
                {name: 'Industry of employment/Travel/Hospitality', text: 'Travel/Hospitality', count: 0},
                {name: 'Industry of employment/Government', text: 'Government', count: 0},
                {name: 'Industry of employment/Military', text: 'Military', count: 0},
                {name: 'Industry of employment/Aerospace', text: 'Aerospace', count: 0},
                {name: 'Industry of employment/Health Care/Medical', text: 'Health Care/Medical', count: 0},
                {name: 'Industry of employment/Insurance/Legal', text: 'Insurance/Legal', count: 0},
                {name: 'Industry of employment/Education', text: 'Education', count: 0},
                {name: 'Industry of employment/Utilities', text: 'Utilities', count: 0},
                {name: 'Industry of employment/Architecture/Construction/Real Estate', text: 'Architecture/Construction/Real Estate', count: 0},
                {name: 'Industry of employment/Agriculture', text: 'Agriculture', count: 0},
                {name: 'Industry of employment/Religious', text: 'Religious', count: 0},
                {name: 'Industry of employment/Social Services', text: 'Social Services', count: 0},
                {name: 'Industry of employment/Sales', text: 'Sales', count: 0},
                {name: 'Industry of employment/Gambling Industry', text: 'Gambling Industry', count: 0},
                {name: 'Industry of employment/None', text: 'None', count: 0},
                {name: 'Industry of employment/N/A', text: 'N/A', count: 0},
            ],
            optMaritalStatus: [
                {name: 'Marital status/Married', text: 'Married', count: 0},
                {name: 'Marital status/Never married', text: 'Never married', count: 0},
                {name: 'Marital status/Living as married', text: 'Living as married', count: 0},
                {name: 'Marital status/Separated', text: 'Separated', count: 0},
                {name: 'Marital status/Divorced', text: 'Divorced', count: 0},
                {name: 'Marital status/Widowed', text: 'Widowed', count: 0},
                {name: 'Marital status/N/A', text: 'N/A', count: 0},
            ],
            optReligiousPreference: [
                {name: 'Religious preference/Catholic', text: 'Catholic', count: 0},
                {name: 'Religious preference/Protestant', text: 'Protestant', count: 0},
                {name: 'Religious preference/Other Christian', text: 'Other Christian', count: 0},
                {name: 'Religious preference/Jewish', text: 'Jewish', count: 0},
                {name: 'Religious preference/Muslim', text: 'Muslim', count: 0},
                {name: 'Religious preference/Buddhist', text: 'Buddhist', count: 0},
                {name: 'Religious preference/Atheist/Agnostic', text: 'Atheist/Agnostic', count: 0},
                {name: 'Religious preference/No preference', text: 'No preference', count: 0},
                {name: 'Religious preference/Other', text: 'Other', count: 0},
                {name: 'Religious preference/N/A', text: 'N/A', count: 0},
            ],
            optPrimaryICD10: [
                {name: 'Primary ICD-10 Diagnosis Code/F 63.0 Pathological Gambling', text: 'F 63.0 Pathological Gambling', count: 0},
                {name: 'Primary ICD-10 Diagnosis Code/Z72.6 Gambling and Betting', text: 'Z72.6 Gambling and Betting', count: 0},
            ],
            optAge: [
                {name: 'Age/Under 18', text: 'Under 18', count: 0},
                {name: 'Age/18 - 24', text: '18 - 24', count: 0},
                {name: 'Age/25 - 34', text: '25 - 34', count: 0},
                {name: 'Age/35 - 44', text: '35 - 44', count: 0},
                {name: 'Age/45 - 54', text: '45 - 54', count: 0},
                {name: 'Age/55 - 64', text: '55 - 64', count: 0},
                {name: 'Age/65+', text: '65+', count: 0},
                {name: 'Age/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optSexualOrientation: [
                {name: 'Sexual Orientation/Bisexual', text: 'Bisexual', count: 0},
                {name: 'Sexual Orientation/Lesbian or Gay', text: 'Lesbian or Gay', count: 0},
                {name: 'Sexual Orientation/Pansexual', text: 'Pansexual', count: 0},
                {name: 'Sexual Orientation/Straight', text: 'Straight', count: 0},
                {name: 'Sexual Orientation/I use a different term', text: 'I use a different term', count: 0},
                {name: 'Sexual Orientation/Questioning/Unsure', text: 'Questioning/Unsure', count: 0},
                {name: 'Sexual Orientation/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optGenderIdentity: [
                {name: 'Gender Identity/Intersex', text: 'Intersex', count: 0},
                {name: 'Gender Identity/Man', text: 'Man', count: 0},
                {name: 'Gender Identity/Non-Binary', text: 'Non-Binary', count: 0},
                {name: 'Gender Identity/Two-Spirit', text: 'Two-Spirit', count: 0},
                {name: 'Gender Identity/Woman', text: 'Woman', count: 0},
                {name: 'Gender Identity/I use a different term', text: 'I use a different term', count: 0},
                {name: 'Gender Identity/Questioning/Unsure', text: 'Questioning/Unsure', count: 0},
                {name: 'Gender Identity/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optTransgender: [
                {name: 'Transgender/Yes', text: 'Yes', count: 0},
                {name: 'Transgender/No', text: 'No', count: 0},
                {name: 'Transgender/Questioning/Unsure', text: 'Questioning/Unsure', count: 0},
                {name: 'Transgender/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optReferredBy: [
                {name: 'How was client referred for services?/HOPEline', text: 'HOPEline', count: 0},
                {name: 'How was client referred for services?/Family member/Self', text: 'Family member/Self', count: 0},
                {name: 'How was client referred for services?/Friends or Other Individual', text: 'Friends or Other Individual', count: 0},
                {name: 'How was client referred for services?/Problem Gambling Self-Help Group Meetings', text: 'Problem Gambling Self-Help Group Meetings', count: 0},
                {name: 'How was client referred for services?/Substance Use Self-Help Group Meetings', text: 'Substance Use Self-Help Group Meetings', count: 0},
                {name: 'How was client referred for services?/Financial Counseling', text: 'Financial Counseling', count: 0},
                {name: 'How was client referred for services?/Crisis Services', text: 'Crisis Services', count: 0},
                {name: 'How was client referred for services?/Problem Gambling Treatment Services', text: 'Problem Gambling Treatment Services', count: 0},
                {name: 'How was client referred for services?/Substance Use Treatment Services', text: 'Substance Use Treatment Services', count: 0},
                {name: 'How was client referred for services?/Recovery Support Services', text: 'Recovery Support Services', count: 0},
                {name: 'How was client referred for services?/Other', text: 'Other', count: 0},
            ],
            optIDisabilityDevelopmentalDisability: [
                {name: 'I. Disability/Developmental Disability/No', text: 'No', count: 0},
                {name: 'I. Disability/Developmental Disability/Yes', text: 'Yes', count: 0},
                {name: 'I. Disability/Developmental Disability/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optPsychiatricDisorder: [
                {name: 'Co-existing Psychiatric Disorder/No', text: 'No', count: 0},
                {name: 'Co-existing Psychiatric Disorder/Yes', text: 'Yes', count: 0},
                {name: 'Co-existing Psychiatric Disorder/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optMentalIllness: [
                {name: 'Treated for Mental Illness/No', text: 'No', count: 0},
                {name: 'Treated for Mental Illness/Yes', text: 'Yes', count: 0},
                {name: 'Treated for Mental Illness/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optHospitalizedforMentalIllness: [
                {name: 'Hospitalized for Mental Illness/No', text: 'No', count: 0},
                {name: 'Hospitalized for Mental Illness/Yes', text: 'Yes', count: 0},
                {name: 'Hospitalized for Mental Illness/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optHospitalized30ormoredays: [
                {name: 'Hospitalized 30 or more days for Mental Illness/No', text: 'No', count: 0},
                {name: 'Hospitalized 30 or more days for Mental Illness/Yes', text: 'Yes', count: 0},
                {name: 'Hospitalized 30 or more days for Mental Illness/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optSmokedtobacco: [
                {name: 'Smoked tobacco in the past week/No', text: 'No', count: 0},
                {name: 'Smoked tobacco in the past week/Yes', text: 'Yes', count: 0},
                {name: 'Smoked tobacco in the past week/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optUsedsmokelesstobacco: [
                {name: 'Used smokeless tobacco in the past week/No', text: 'No', count: 0},
                {name: 'Used smokeless tobacco in the past week/Yes', text: 'Yes', count: 0},
                {name: 'Used smokeless tobacco in the past week/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optSubstancesUsed: [
                {name: 'Substances Used/None', text: 'None', count: 0},
                {name: 'Substances Used/Prefer not to answer', text: 'Prefer not to answer', count: 0},
                {name: 'Substances Used/Alcohol', text: 'Alcohol', count: 0},
                {name: 'Substances Used/Cocaine', text: 'Cocaine', count: 0},
                {name: 'Substances Used/Crack', text: 'Crack', count: 0},
                {name: 'Substances Used/Marijuana/Hashish', text: 'Marijuana/Hashish', count: 0},
                {name: 'Substances Used/Heroin', text: 'Heroin', count: 0},
                {name: 'Substances Used/Buprenorphine', text: 'Buprenorphine', count: 0},
                {name: 'Substances Used/Non-Rx Methadone', text: 'Non-Rx Methadone', count: 0},
                {name: 'Substances Used/OxyContin', text: 'OxyContin', count: 0},
                {name: 'Substances Used/Other Opiate/Synthetic', text: 'Other Opiate/Synthetic', count: 0},
                {name: 'Substances Used/Alprazolam (Xanax)', text: 'Alprazolam (Xanax)', count: 0},
                {name: 'Substances Used/Barbiturate', text: 'Barbiturate', count: 0},
                {name: 'Substances Used/Benzodiazepine (Klonopin)', text: 'Benzodiazepine (Klonopin)', count: 0},
                {name: 'Substances Used/Catapres (Clonidine)', text: 'Catapres (Clonidine)', count: 0},
                {name: 'Substances Used/Other Sedative/Hypnotic', text: 'Other Sedative/Hypnotic', count: 0},
                {name: 'Substances Used/Elavil', text: 'Elavil', count: 0},
                {name: 'Substances Used/GHB', text: 'GHB', count: 0},
                {name: 'Substances Used/Khat', text: 'Khat', count: 0},
                {name: 'Substances Used/Other Tranquilizer', text: 'Other Tranquilizer', count: 0},
                {name: 'Substances Used/Methamphetamine', text: 'Methamphetamine', count: 0},
                {name: 'Substances Used/Other Amphetamine', text: 'Other Amphetamine', count: 0},
                {name: 'Substances Used/Other Stimulant', text: 'Other Stimulant', count: 0},
                {name: 'Substances Used/PCP', text: 'PCP', count: 0},
                {name: 'Substances Used/Ecstasy', text: 'Ecstasy', count: 0},
                {name: 'Substances Used/Other Hallucinogen', text: 'Other Hallucinogen', count: 0},
                {name: 'Substances Used/Ephedrine', text: 'Ephedrine', count: 0},
                {name: 'Substances Used/Inhalant', text: 'Inhalant', count: 0},
                {name: 'Substances Used/Ketamine', text: 'Ketamine', count: 0},
                {name: 'Substances Used/Rohypnol', text: 'Rohypnol', count: 0},
                {name: 'Substances Used/Over the counter', text: 'Over the counter', count: 0},
                {name: 'Substances Used/Other', text: 'Other', count: 0},
            ],
            optSubstanceUseRouteOfAdministration: [
                {name: 'Substance Use Route of Administration/N/A', text: 'N/A', count: 0},
                {name: 'Substance Use Route of Administration/Prefer not to answer', text: 'Prefer not to answer', count: 0},
                {name: 'Substance Use Route of Administration/Inhalation', text: 'Inhalation', count: 0},
                {name: 'Substance Use Route of Administration/Injection', text: 'Injection', count: 0},
                {name: 'Substance Use Route of Administration/Oral', text: 'Oral', count: 0},
                {name: 'Substance Use Route of Administration/Smoking', text: 'Smoking', count: 0},
                {name: 'Substance Use Route of Administration/Vaping', text: 'Vaping', count: 0},
                {name: 'Substance Use Route of Administration/Other', text: 'Other', count: 0},
            ],
            optFrequencyOfSubstanceUse: [
                {name: 'Frequency of Substance Use/N/A', text: 'N/A', count: 0},
                {name: 'Frequency of Substance Use/Prefer not to answer', text: 'Prefer not to answer', count: 0},
                {name: 'Frequency of Substance Use/No use in past 30 days', text: 'No use in past 30 days', count: 0},
                {name: 'Frequency of Substance Use/1 - 3 times in the past 30 days', text: '1 - 3 times in the past 30 days', count: 0},
                {name: 'Frequency of Substance Use/1 - 2 times per week', text: '1 - 2 times per week', count: 0},
                {name: 'Frequency of Substance Use/3 - 6 times per week', text: '3 - 6 times per week', count: 0},
                {name: 'Frequency of Substance Use/Daily', text: 'Daily', count: 0},
            ],
            optFrequencyofGambling: [
                {name: 'Frequency of Gambling/None in the last 30 days', text: 'None in the last 30 days', count: 0},
                {name: 'Frequency of Gambling/1 - 3 times in the last 30 days', text: '1 - 3 times in the last 30 days', count: 0},
                {name: 'Frequency of Gambling/1 - 2 times per week', text: '1 - 2 times per week', count: 0},
                {name: 'Frequency of Gambling/3 - 6 times per week', text: '3 - 6 times per week', count: 0},
                {name: 'Frequency of Gambling/Daily', text: 'Daily', count: 0},
                {name: 'Frequency of Gambling/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optGamblinglocationspast12months: [
                {name: 'Gambling locations during the past 12 months/None', text: 'None', count: 0},
                {name: 'Gambling locations during the past 12 months/Casino', text: 'Casino', count: 0},
                {name: 'Gambling locations during the past 12 months/Race track', text: 'Race track', count: 0},
                {name: 'Gambling locations during the past 12 months/Grocery/Convenience Store', text: 'Grocery/Convenience Store', count: 0},
                {name: 'Gambling locations during the past 12 months/Internet', text: 'Internet', count: 0},
                {name: 'Gambling locations during the past 12 months/Off-Track Betting (OTB)', text: 'Off-Track Betting (OTB)', count: 0},
                {name: 'Gambling locations during the past 12 months/Bookie', text: 'Bookie', count: 0},
                {name: 'Gambling locations during the past 12 months/Bar/Restaurant', text: 'Bar/Restaurant', count: 0},
                {name: 'Gambling locations during the past 12 months/Work', text: 'Work', count: 0},
                {name: 'Gambling locations during the past 12 months/School', text: 'School', count: 0},
                {name: 'Gambling locations during the past 12 months/Home', text: 'Home', count: 0},
                {name: 'Gambling locations during the past 12 months/Church', text: 'Church', count: 0},
                {name: 'Gambling locations during the past 12 months/Community Site', text: 'Community Site', count: 0},
                {name: 'Gambling locations during the past 12 months/Other', text: 'Other', count: 0},
                {name: 'Gambling locations during the past 12 months/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
            optHasClientAttendedReceivedServices: [
                {name: 'Has client attended or received services for any reason from/Self-Help', text: 'Self-Help', count: 0},
                {name: 'Has client attended or received services for any reason from/Other Gambling Program', text: 'Other Gambling Program', count: 0},
                {name: 'Has client attended or received services for any reason from/Financial and/or Credit Counseling Service', text: 'Financial and/or Credit Counseling Service', count: 0},
                {name: 'Has client attended or received services for any reason from/N/A', text: 'N/A', count: 0},
                {name: 'Has client attended or received services for any reason from/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ],
        }
    },
    components: {
        BForm,
        BButton,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        BTable,
        BFormInvalidFeedback,
        BFormSelect,
        BCard,
        BAvatar,
        BCardBody,
        BSpinner,
        BFormRadioGroup,
        BFormRadio,
        DatePicker,
        
        // select
        vSelect,

        // date
        flatPickr,

        // Form Validation
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        Ripple,
    },
    computed: {
        ...mapGetters(['arrayFiltradoReportsActiveTreatment','arrayFiltradoReportsActiveTreatmentClaims']),
        ...mapState(['searchReportsActiveTreatmentStartDateState','searchReportsActiveTreatmentEndDateState','searchReportsActiveTreatmentRegionState','searchReportsActiveTreatmentProgressState','searchReportsActiveTreatmentLanguageState','searchReportsActiveTreatmentInsuranceState','searchReportsActiveTreatmentProgramState'])
    },
    watch: {
        selectedRangeDate(val) {
            this.functionDateRange(val)
        },
        clientActivityStatus(val) {
            this.searchClientActivityStatus(val)
        },
        startDate(val) {
            // console.log(val)
            this.searchReportsActiveTreatmentStartDate(val)
            this.functionDateRange(this.selectedRangeDate)
            this.rangeDinamic ? this.rangeDinamic = false : ''
            // this.selectedRangeDate = ''
        },
        endDate(val) {
            // console.log(val)
            this.searchReportsActiveTreatmentEndDate(val)
        },
        region(val) {
            this.searchReportsActiveTreatmentRegion(val)
        },
        borough(val) {
            this.searchReportsActiveTreatmentRegion(val)
        },
        progress(val) {
            this.searchReportsActiveTreatmentProgress(val)
        },
        language(val) {
            this.searchReportsActiveTreatmentLanguage(val)
        },
        insurance(val) {
            this.searchReportsActiveTreatmentInsurance(val)
        },
        clinicianProgram(val) {
            this.searchReportsActiveTreatmentProgram(val)
        },
        newOrReturningClient(val) {
            this.searchReportsActiveTreatmentnewOrReturningClient(val)
        },
        clientStatusAdmission(val) {
            this.searchReportsActiveTreatmentclientStatusAdmission(val)
        },
        presentingProblemsAtAdmission(val) {
            this.searchReportsActiveTreatmentpresentingProblemsAtAdmission(val)
        },
        diagnosticCriteriaMetAtAdmission(val) {
            this.searchReportsActiveTreatmentdiagnosticCriteriaMetAtAdmission(val)
        },
        clientInvolvedWithLegalSystem(val) {
            this.searchReportsActiveTreatmentclientInvolvedWithLegalSystem(val)
        },
        clientReleaseSigned(val) {
            this.searchReportsActiveTreatmentclientReleaseSigned(val)
        },
        race(val) {
            this.searchReportsActiveTreatmentrace(val)
        },
        ethnicity(val) {
            this.searchReportsActiveTreatmentethnicity(val)
        },
        asianOrigin(val) {
            this.searchReportsActiveTreatmentasianOrigin(val)
        },
        pacificIslanderOrigin(val) {
            this.searchReportsActiveTreatmentpacificIslanderOrigin(val)
        },
        householdIncome(val) {
            this.searchReportsActiveTreatmenthouseholdIncome(val)
        },
        gamblingTypes(val) {
            this.searchReportsActiveTreatmentgamblingTypes(val)
        },
        employmentStatus(val) {
            this.searchReportsActiveTreatmentemploymentStatus(val)
        },
        educationLevels(val) {
            this.searchReportsActiveTreatmenteducationLevels(val)
        },
        veteran(val) {
            this.searchReportsActiveTreatmentveteran(val)
        },
        industryOfEmployment(val) {
            this.searchReportsActiveTreatmentindustryOfEmployment(val)
        },
        maritalStatus(val) {
            this.searchReportsActiveTreatmentmaritalStatus(val)
        },
        religiousPreference(val) {
            this.searchReportsActiveTreatmentreligiousPreference(val)
        },
        primaryICD10(val) {
            this.searchReportsActiveTreatmentprimaryICD10(val)
        },
        age(val) {
            this.searchReportsActiveTreatmentage(val)
        },
        sexualOrientation(val) {
            this.searchReportsActiveTreatmentsexualOrientation(val)
        },
        genderIdentity(val) {
            this.searchReportsActiveTreatmentgenderIdentity(val)
        },
        transgender(val) {
            this.searchReportsActiveTreatmenttransgender(val)
        },
        referredByAdmission(val) {
            this.searchReportsActiveTreatmentreferredByAdmission(val)
        },
        developmentalDisability(val) {
            this.searchReportsActiveTreatmentdevelopmentalDisability(val)
        },
        coexistingPsychiatricDisorder(val) {
            this.searchReportsActiveTreatmentcoexistingPsychiatricDisorder(val)
        },
        treatedForMentalIllness(val) {
            this.searchReportsActiveTreatmenttreatedForMentalIllness(val)
        },
        hospitalizedForMentalIllness(val) {
            this.searchReportsActiveTreatmenthospitalizedForMentalIllness(val)
        },
        hospitalized30OrMoreDaysForMentalIllness(val) {
            this.searchReportsActiveTreatmenthospitalized30OrMoreDaysForMentalIllness(val)
        },
        smokedTobaccoInThePastWeek(val) {
            this.searchReportsActiveTreatmentsmokedTobaccoInThePastWeek(val)
        },
        usedSmokelessTobaccoInThePastWeek(val) {
            this.searchReportsActiveTreatmentusedSmokelessTobaccoInThePastWeek(val)
        },
        substancesUsed(val) {
            this.searchReportsActiveTreatmentsubstancesUsed(val)
        },
        substanceUseRouteOfAdministration(val) {
            this.searchReportsActiveTreatmentsubstanceUseRouteOfAdministration(val)
        },
        frequencyOfSubstanceUse(val) {
            this.searchReportsActiveTreatmentfrequencyOfSubstanceUse(val)
        },
        frequencyofGambling(val) {
            this.searchReportsActiveTreatmentfrequencyofGambling(val)
        },
        gamblinglocationspast12months(val) {
            this.searchReportsActiveTreatmentgamblinglocationspast12months(val)
        },
        hasClientAttendedReceivedServices(val) {
            this.searchReportsActiveTreatmenthasClientAttendedReceivedServices(val)
        },
        arrayFiltradoReportsActiveTreatment(val) {
            // this.isBusy = true
            this.countTotalClientsInTreatment = 0
            this.countTotalFamilyMembersInTreatment = 0
            this.countTotalGamblersInTreatment = 0
            this.averageLengthOfStay = 0
            this.totalNonEnglishClients = 0
            this.countOtherBlank = 0
            var test = 0
            var test1 = 0
            var test2 = 0
            var test3 = 0
            var other = 0
            var arr = []
            var arrayExport = []
            this.countReturningClient = 0
            this.countNewClient = 0
            this.readyToExport = false
            this.countPPAACOMHD = 0
            this.countPPAACOSUD = 0
            this.countPPAAED = 0
            this.countPPAAFD = 0
            this.countPPAAPHP = 0
            this.countPPAARD = 0
            this.countPPAAED = 0
            this.countPPAAMD = 0
            this.countPPAAB = 0
            this.countPPAABOTFFF = 0
            this.countPPAALSR = 0
            this.countPPAASD = 0
            this.countPPAAE = 0
            this.countPPAASITA = 0
            this.countPPAALI = 0
            this.countPPAAA = 0
            this.countPPAAINCA = 0
            this.countPPAANA = 0
            this.countDCMAANA = 0
            this.countDCMAAALMGOR = 0
            this.countDCMAAHJLASR = 0
            this.countDCMAAHMRUETC = 0
            this.countDCMAAIOPW = 0
            this.countDCMAAIROIWA = 0
            this.countDCMAALTCTE = 0
            this.countDCMAAOGWFD = 0
            this.countDCMAANTGWI = 0
            this.countDCMAAROOTPM = 0
            this.countCIWLSYES = 0
            this.countCIWLSNO = 0
            this.countCIWLSNA = 0
            this.countCRSYES = 0
            this.countCRSNO = 0
            this.countCRSNA = 0
            this.countRaceAN = 0
            this.countRaceAs = 0
            this.countRaceBOAA = 0
            this.countRaceHOOOPI = 0
            this.countRaceMEONA = 0
            this.countRaceNAIOAI = 0
            this.countRaceWH = 0
            this.countRaceSOREO = 0
            this.countRacePNTA = 0
            this.countEthnicityCUB = 0
            this.countEthnicityMEX = 0
            this.countEthnicityPR = 0
            this.countEthnicityHLNS = 0
            this.countEthnicityNOTH = 0
            this.countEthnicityPNTA = 0
            this.countAsianAIN = 0
            this.countAsianBANG = 0
            this.countAsianBURM = 0
            this.countAsianCAMB = 0
            this.countAsianCHIN = 0
            this.countAsianFIL = 0
            this.countAsianHMONG = 0
            this.countAsianINDO = 0
            this.countAsianJAP = 0
            this.countAsianKOR = 0
            this.countAsianLAOT = 0
            this.countAsianMALA = 0
            this.countAsianNEPA = 0
            this.countAsianPAKI = 0
            this.countAsianSRI = 0
            this.countAsianTAIW = 0
            this.countAsianTHAI = 0
            this.countAsianTIB = 0
            this.countAsianVIET = 0
            this.countAsianNSPE = 0
            this.countAsianNAORI = 0
            this.countAsianPNTA = 0

            this.optPacificIslanderOrigin = [
                {name: 'Pacific Islander Origin/Fijian', text: 'Fijian', count: 0},
                {name: 'Pacific Islander Origin/Guamanian', text: 'Guamanian', count: 0},
                {name: 'Pacific Islander Origin/Hawaiian', text: 'Hawaiian', count: 0},
                {name: 'Pacific Islander Origin/Samoan', text: 'Samoan', count: 0},
                {name: 'Pacific Islander Origin/Tongan', text: 'Tongan', count: 0},
                {name: 'Pacific Islander Origin/Pacific Islander, Not Specified', text: 'Pacific Islander, Not Specified', count: 0},
                {name: 'Pacific Islander Origin/Not of Pacific Islander Origin', text: 'Not of Pacific Islander Origin', count: 0},
                {name: 'Pacific Islander Origin/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optHouseholdIncome = [
                {name: 'Household Income/$15,000 - $30,000', text: '$15,000 - $30,000', count: 0},
                {name: 'Household Income/$30,001 - $50,000', text: '$30,001 - $50,000', count: 0},
                {name: 'Household Income/$50,001 - $75,000', text: '$50,001 - $75,000', count: 0},
                {name: 'Household Income/$75,001 - $100,000', text: '$75,001 - $100,000', count: 0},
                {name: 'Household Income/Less than $15,000', text: 'Less than $15,000', count: 0},
                {name: 'Household Income/More than $100,000', text: 'More than $100,000', count: 0},
                {name: 'Household Income/N/A', text: 'N/A', count: 0},
            ]
            this.optGamblingTypes = [
                {name: 'Types of Gambling Engaged In/None', text: 'None', count: 0},
                {name: 'Types of Gambling Engaged In/Office pools', text: 'Office pools', count: 0},
                {name: 'Types of Gambling Engaged In/Roulette', text: 'Roulette', count: 0},
                {name: 'Types of Gambling Engaged In/Slot machines', text: 'Slot machines', count: 0},
                {name: 'Types of Gambling Engaged In/Sports', text: 'Sports', count: 0},
                {name: 'Types of Gambling Engaged In/Stock/commodities market', text: 'Stock/commodities market', count: 0},
                {name: 'Types of Gambling Engaged In/Video lottery terminal (VLT)', text: 'Video lottery terminal (VLT)', count: 0},
                {name: 'Types of Gambling Engaged In/Dice games/coin flips', text: 'Dice games/coin flips', count: 0},
                {name: 'Types of Gambling Engaged In/Lottery (Numbers, Scratch offs, Quick Draw)', text: 'Lottery (Numbers, Scratch offs, Quick Draw)', count: 0},
                {name: 'Types of Gambling Engaged In/Game of skill for money (video games, bowling, pool, etc)', text: 'Game of skill for money (video games, bowling, pool, etc)', count: 0},
                {name: 'Types of Gambling Engaged In/Raffles (including 50/50 or pull tabs)', text: 'Raffles (including 50/50 or pull tabs)', count: 0},
                {name: 'Types of Gambling Engaged In/Native American (Turning Stone, Seneca, Ankwesasne, etc)', text: 'Native American (Turning Stone, Seneca, Ankwesasne, etc)', count: 0},
                {name: 'Types of Gambling Engaged In/Gambling on the internet (eGaming)', text: 'Gambling on the internet (eGaming)', count: 0},
                {name: 'Types of Gambling Engaged In/Commercial casinos (Tioga, Del Lago, Resorts World Catskills, Rivers, etc)', text: 'Commercial casinos (Tioga, Del Lago, Resorts World Catskills, Rivers, etc)', count: 0},
                {name: 'Types of Gambling Engaged In/Sports betting at a casino', text: 'Sports betting at a casino', count: 0},
                {name: 'Types of Gambling Engaged In/Mobile sports betting', text: 'Mobile sports betting', count: 0},
                {name: 'Types of Gambling Engaged In/Prefer not to answer', text: 'Prefer not to answer', count: 0},
                {name: 'Types of Gambling Engaged In/Bingo', text: 'Bingo', count: 0},
                {name: 'Types of Gambling Engaged In/Cards', text: 'Cards', count: 0},
                {name: 'Types of Gambling Engaged In/Horses', text: 'Horses', count: 0},
                {name: 'Types of Gambling Engaged In/Dogs/other animal', text: 'Dogs/other animal', count: 0},
            ]
            this.optEmploymentStatus = [
                {name: 'Employment Status/Employed Full Time – 35 hours or more/week', text: 'Employed Full Time – 35 hours or more/week', count: 0},
                {name: 'Employment Status/Employed Part Time – less than 35 hours/week', text: 'Employed Part Time – less than 35 hours/week', count: 0},
                {name: 'Employment Status/Unemployed, looking for work', text: 'Unemployed, looking for work', count: 0},
                {name: 'Employment Status/Unemployed, not looking for work', text: 'Unemployed, not looking for work', count: 0},
                {name: 'Employment Status/Not in Labor Force, Retired', text: 'Not in Labor Force, Retired', count: 0},
                {name: 'Employment Status/Not in Labor Force, Disabled', text: 'Not in Labor Force, Disabled', count: 0},
                {name: 'Employment Status/Not in Labor Force, Student', text: 'Not in Labor Force, Student', count: 0},
                {name: 'Employment Status/Not in Labor Force, Other', text: 'Not in Labor Force, Other', count: 0},
                {name: 'Employment Status/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optEducationLevels = [
                {name: 'Highest Grade Completed/No Education', text: 'No Education', count: 0},
                {name: 'Highest Grade Completed/1st grade', text: '1st grade', count: 0},
                {name: 'Highest Grade Completed/2st grade', text: '2st grade', count: 0},
                {name: 'Highest Grade Completed/3st grade', text: '3st grade', count: 0},
                {name: 'Highest Grade Completed/4st grade', text: '4st grade', count: 0},
                {name: 'Highest Grade Completed/5st grade', text: '5st grade', count: 0},
                {name: 'Highest Grade Completed/6st grade', text: '6st grade', count: 0},
                {name: 'Highest Grade Completed/7st grade', text: '7st grade', count: 0},
                {name: 'Highest Grade Completed/8st grade', text: '8st grade', count: 0},
                {name: 'Highest Grade Completed/9st grade', text: '9st grade', count: 0},
                {name: 'Highest Grade Completed/10st grade', text: '10st grade', count: 0},
                {name: 'Highest Grade Completed/11st grade', text: '11st grade', count: 0},
                {name: 'Highest Grade Completed/High school Diploma', text: 'High school Diploma', count: 0},
                {name: 'Highest Grade Completed/General Equivalency Diploma (GED)', text: 'General Equivalency Diploma (GED)', count: 0},
                {name: 'Highest Grade Completed/Vocational Certificate w/out Diploma/GED', text: 'Vocational Certificate w/out Diploma/GED', count: 0},
                {name: 'Highest Grade Completed/Vocational Certificate w/ Diploma/GED', text: 'Vocational Certificate w/ Diploma/GED', count: 0},
                {name: 'Highest Grade Completed/Some College – No Degree', text: 'Some College – No Degree', count: 0},
                {name: 'Highest Grade Completed/Associate’s Degree', text: 'Associate’s Degree', count: 0},
                {name: 'Highest Grade Completed/Bachelor’s Degree', text: 'Bachelor’s Degree', count: 0},
                {name: 'Highest Grade Completed/Graduate Degree', text: 'Graduate Degree', count: 0},
                {name: 'Highest Grade Completed/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optVeteran = [
                {name: 'Veteran/Yes', text: 'Yes', count: 0},
                {name: 'Veteran/No', text: 'No', count: 0},
                {name: 'Veteran/N/A', text: 'N/A', count: 0},
            ]
            this.optIndustryOfEmployment = [
                {name: 'Industry of employment/Business', text: 'Business', count: 0},
                {name: 'Industry of employment/Computer', text: 'Computer', count: 0},
                {name: 'Industry of employment/Telecommunications', text: 'Telecommunications', count: 0},
                {name: 'Industry of employment/Financial Services', text: 'Financial Services', count: 0},
                {name: 'Industry of employment/Manufacturing', text: 'Manufacturing', count: 0},
                {name: 'Industry of employment/Wholesale/Retail/Distribution', text: 'Wholesale/Retail/Distribution', count: 0},
                {name: 'Industry of employment/Transportation', text: 'Transportation', count: 0},
                {name: 'Industry of employment/Travel/Hospitality', text: 'Travel/Hospitality', count: 0},
                {name: 'Industry of employment/Government', text: 'Government', count: 0},
                {name: 'Industry of employment/Military', text: 'Military', count: 0},
                {name: 'Industry of employment/Aerospace', text: 'Aerospace', count: 0},
                {name: 'Industry of employment/Health Care/Medical', text: 'Health Care/Medical', count: 0},
                {name: 'Industry of employment/Insurance/Legal', text: 'Insurance/Legal', count: 0},
                {name: 'Industry of employment/Education', text: 'Education', count: 0},
                {name: 'Industry of employment/Utilities', text: 'Utilities', count: 0},
                {name: 'Industry of employment/Architecture/Construction/Real Estate', text: 'Architecture/Construction/Real Estate', count: 0},
                {name: 'Industry of employment/Agriculture', text: 'Agriculture', count: 0},
                {name: 'Industry of employment/Religious', text: 'Religious', count: 0},
                {name: 'Industry of employment/Social Services', text: 'Social Services', count: 0},
                {name: 'Industry of employment/Sales', text: 'Sales', count: 0},
                {name: 'Industry of employment/Gambling Industry', text: 'Gambling Industry', count: 0},
                {name: 'Industry of employment/None', text: 'None', count: 0},
                {name: 'Industry of employment/N/A', text: 'N/A', count: 0},
            ]
            this.optMaritalStatus = [
                {name: 'Marital status/Married', text: 'Married', count: 0},
                {name: 'Marital status/Never married', text: 'Never married', count: 0},
                {name: 'Marital status/Living as married', text: 'Living as married', count: 0},
                {name: 'Marital status/Separated', text: 'Separated', count: 0},
                {name: 'Marital status/Divorced', text: 'Divorced', count: 0},
                {name: 'Marital status/Widowed', text: 'Widowed', count: 0},
                {name: 'Marital status/N/A', text: 'N/A', count: 0},
            ]
            this.optReligiousPreference = [
                {name: 'Religious preference/Catholic', text: 'Catholic', count: 0},
                {name: 'Religious preference/Protestant', text: 'Protestant', count: 0},
                {name: 'Religious preference/Other Christian', text: 'Other Christian', count: 0},
                {name: 'Religious preference/Jewish', text: 'Jewish', count: 0},
                {name: 'Religious preference/Muslim', text: 'Muslim', count: 0},
                {name: 'Religious preference/Buddhist', text: 'Buddhist', count: 0},
                {name: 'Religious preference/Atheist/Agnostic', text: 'Atheist/Agnostic', count: 0},
                {name: 'Religious preference/No preference', text: 'No preference', count: 0},
                {name: 'Religious preference/Other', text: 'Other', count: 0},
                {name: 'Religious preference/N/A', text: 'N/A', count: 0},
            ]
            this.optPrimaryICD10 = [
                {name: 'Primary ICD-10 Diagnosis Code/F 63.0 Pathological Gambling', text: 'F 63.0 Pathological Gambling', count: 0},
                {name: 'Primary ICD-10 Diagnosis Code/Z72.6 Gambling and Betting', text: 'Z72.6 Gambling and Betting', count: 0},
            ]
            this.optAge = [
                {name: 'Age/Under 18', text: 'Under 18', count: 0},
                {name: 'Age/18 - 24', text: '18 - 24', count: 0},
                {name: 'Age/25 - 34', text: '25 - 34', count: 0},
                {name: 'Age/35 - 44', text: '35 - 44', count: 0},
                {name: 'Age/45 - 54', text: '45 - 54', count: 0},
                {name: 'Age/55 - 64', text: '55 - 64', count: 0},
                {name: 'Age/65+', text: '65+', count: 0},
                {name: 'Age/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optSexualOrientation = [
                {name: 'Sexual Orientation/Bisexual', text: 'Bisexual', count: 0},
                {name: 'Sexual Orientation/Lesbian or Gay', text: 'Lesbian or Gay', count: 0},
                {name: 'Sexual Orientation/Pansexual', text: 'Pansexual', count: 0},
                {name: 'Sexual Orientation/Straight', text: 'Straight', count: 0},
                {name: 'Sexual Orientation/I use a different term', text: 'I use a different term', count: 0},
                {name: 'Sexual Orientation/Questioning/Unsure', text: 'Questioning/Unsure', count: 0},
                {name: 'Sexual Orientation/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optGenderIdentity = [
                {name: 'Gender Identity/Intersex', text: 'Intersex', count: 0},
                {name: 'Gender Identity/Man', text: 'Man', count: 0},
                {name: 'Gender Identity/Non-Binary', text: 'Non-Binary', count: 0},
                {name: 'Gender Identity/Two-Spirit', text: 'Two-Spirit', count: 0},
                {name: 'Gender Identity/Woman', text: 'Woman', count: 0},
                {name: 'Gender Identity/I use a different term', text: 'I use a different term', count: 0},
                {name: 'Gender Identity/Questioning/Unsure', text: 'Questioning/Unsure', count: 0},
                {name: 'Gender Identity/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optTransgender = [
                {name: 'Transgender/Yes', text: 'Yes', count: 0},
                {name: 'Transgender/No', text: 'No', count: 0},
                {name: 'Transgender/Questioning/Unsure', text: 'Questioning/Unsure', count: 0},
                {name: 'Transgender/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optReferredBy = [
                {name: 'How was client referred for services?/HOPEline', text: 'HOPEline', count: 0},
                {name: 'How was client referred for services?/Family member/Self', text: 'Family member/Self', count: 0},
                {name: 'How was client referred for services?/Friends or Other Individual', text: 'Friends or Other Individual', count: 0},
                {name: 'How was client referred for services?/Problem Gambling Self-Help Group Meetings', text: 'Problem Gambling Self-Help Group Meetings', count: 0},
                {name: 'How was client referred for services?/Substance Use Self-Help Group Meetings', text: 'Substance Use Self-Help Group Meetings', count: 0},
                {name: 'How was client referred for services?/Financial Counseling', text: 'Financial Counseling', count: 0},
                {name: 'How was client referred for services?/Crisis Services', text: 'Crisis Services', count: 0},
                {name: 'How was client referred for services?/Problem Gambling Treatment Services', text: 'Problem Gambling Treatment Services', count: 0},
                {name: 'How was client referred for services?/Substance Use Treatment Services', text: 'Substance Use Treatment Services', count: 0},
                {name: 'How was client referred for services?/Recovery Support Services', text: 'Recovery Support Services', count: 0},
                {name: 'How was client referred for services?/Other', text: 'Other', count: 0},
            ]
            this.optIDisabilityDevelopmentalDisability = [
                {name: 'I. Disability/Developmental Disability/No', text: 'No', count: 0},
                {name: 'I. Disability/Developmental Disability/Yes', text: 'Yes', count: 0},
                {name: 'I. Disability/Developmental Disability/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optPsychiatricDisorder = [
                {name: 'Co-existing Psychiatric Disorder/No', text: 'No', count: 0},
                {name: 'Co-existing Psychiatric Disorder/Yes', text: 'Yes', count: 0},
                {name: 'Co-existing Psychiatric Disorder/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optMentalIllness = [
                {name: 'Treated for Mental Illness/No', text: 'No', count: 0},
                {name: 'Treated for Mental Illness/Yes', text: 'Yes', count: 0},
                {name: 'Treated for Mental Illness/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optHospitalizedforMentalIllness = [
                {name: 'Hospitalized for Mental Illness/No', text: 'No', count: 0},
                {name: 'Hospitalized for Mental Illness/Yes', text: 'Yes', count: 0},
                {name: 'Hospitalized for Mental Illness/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optHospitalized30ormoredays = [
                {name: 'Hospitalized 30 or more days for Mental Illness/No', text: 'No', count: 0},
                {name: 'Hospitalized 30 or more days for Mental Illness/Yes', text: 'Yes', count: 0},
                {name: 'Hospitalized 30 or more days for Mental Illness/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optSmokedtobacco = [
                {name: 'Smoked tobacco in the past week/No', text: 'No', count: 0},
                {name: 'Smoked tobacco in the past week/Yes', text: 'Yes', count: 0},
                {name: 'Smoked tobacco in the past week/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optUsedsmokelesstobacco = [
                {name: 'Used smokeless tobacco in the past week/No', text: 'No', count: 0},
                {name: 'Used smokeless tobacco in the past week/Yes', text: 'Yes', count: 0},
                {name: 'Used smokeless tobacco in the past week/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optSubstancesUsed = [
                {name: 'Substances Used/None', text: 'None', count: 0},
                {name: 'Substances Used/Prefer not to answer', text: 'Prefer not to answer', count: 0},
                {name: 'Substances Used/Alcohol', text: 'Alcohol', count: 0},
                {name: 'Substances Used/Cocaine', text: 'Cocaine', count: 0},
                {name: 'Substances Used/Crack', text: 'Crack', count: 0},
                {name: 'Substances Used/Marijuana/Hashish', text: 'Marijuana/Hashish', count: 0},
                {name: 'Substances Used/Heroin', text: 'Heroin', count: 0},
                {name: 'Substances Used/Buprenorphine', text: 'Buprenorphine', count: 0},
                {name: 'Substances Used/Non-Rx Methadone', text: 'Non-Rx Methadone', count: 0},
                {name: 'Substances Used/OxyContin', text: 'OxyContin', count: 0},
                {name: 'Substances Used/Other Opiate/Synthetic', text: 'Other Opiate/Synthetic', count: 0},
                {name: 'Substances Used/Alprazolam (Xanax)', text: 'Alprazolam (Xanax)', count: 0},
                {name: 'Substances Used/Barbiturate', text: 'Barbiturate', count: 0},
                {name: 'Substances Used/Benzodiazepine (Klonopin)', text: 'Benzodiazepine (Klonopin)', count: 0},
                {name: 'Substances Used/Catapres (Clonidine)', text: 'Catapres (Clonidine)', count: 0},
                {name: 'Substances Used/Other Sedative/Hypnotic', text: 'Other Sedative/Hypnotic', count: 0},
                {name: 'Substances Used/Elavil', text: 'Elavil', count: 0},
                {name: 'Substances Used/GHB', text: 'GHB', count: 0},
                {name: 'Substances Used/Khat', text: 'Khat', count: 0},
                {name: 'Substances Used/Other Tranquilizer', text: 'Other Tranquilizer', count: 0},
                {name: 'Substances Used/Methamphetamine', text: 'Methamphetamine', count: 0},
                {name: 'Substances Used/Other Amphetamine', text: 'Other Amphetamine', count: 0},
                {name: 'Substances Used/Other Stimulant', text: 'Other Stimulant', count: 0},
                {name: 'Substances Used/PCP', text: 'PCP', count: 0},
                {name: 'Substances Used/Ecstasy', text: 'Ecstasy', count: 0},
                {name: 'Substances Used/Other Hallucinogen', text: 'Other Hallucinogen', count: 0},
                {name: 'Substances Used/Ephedrine', text: 'Ephedrine', count: 0},
                {name: 'Substances Used/Inhalant', text: 'Inhalant', count: 0},
                {name: 'Substances Used/Ketamine', text: 'Ketamine', count: 0},
                {name: 'Substances Used/Rohypnol', text: 'Rohypnol', count: 0},
                {name: 'Substances Used/Over the counter', text: 'Over the counter', count: 0},
                {name: 'Substances Used/Other', text: 'Other', count: 0},
            ]
            this.optSubstanceUseRouteOfAdministration = [
                {name: 'Substance Use Route of Administration/N/A', text: 'N/A', count: 0},
                {name: 'Substance Use Route of Administration/Prefer not to answer', text: 'Prefer not to answer', count: 0},
                {name: 'Substance Use Route of Administration/Inhalation', text: 'Inhalation', count: 0},
                {name: 'Substance Use Route of Administration/Injection', text: 'Injection', count: 0},
                {name: 'Substance Use Route of Administration/Oral', text: 'Oral', count: 0},
                {name: 'Substance Use Route of Administration/Smoking', text: 'Smoking', count: 0},
                {name: 'Substance Use Route of Administration/Vaping', text: 'Vaping', count: 0},
                {name: 'Substance Use Route of Administration/Other', text: 'Other', count: 0},
            ]
            this.optFrequencyOfSubstanceUse = [
                {name: 'Frequency of Substance Use/N/A', text: 'N/A', count: 0},
                {name: 'Frequency of Substance Use/Prefer not to answer', text: 'Prefer not to answer', count: 0},
                {name: 'Frequency of Substance Use/No use in past 30 days', text: 'No use in past 30 days', count: 0},
                {name: 'Frequency of Substance Use/1 - 3 times in the past 30 days', text: '1 - 3 times in the past 30 days', count: 0},
                {name: 'Frequency of Substance Use/1 - 2 times per week', text: '1 - 2 times per week', count: 0},
                {name: 'Frequency of Substance Use/3 - 6 times per week', text: '3 - 6 times per week', count: 0},
                {name: 'Frequency of Substance Use/Daily', text: 'Daily', count: 0},
            ]
            this.optFrequencyofGambling = [
                {name: 'Frequency of Gambling/None in the last 30 days', text: 'None in the last 30 days', count: 0},
                {name: 'Frequency of Gambling/1 - 3 times in the last 30 days', text: '1 - 3 times in the last 30 days', count: 0},
                {name: 'Frequency of Gambling/1 - 2 times per week', text: '1 - 2 times per week', count: 0},
                {name: 'Frequency of Gambling/3 - 6 times per week', text: '3 - 6 times per week', count: 0},
                {name: 'Frequency of Gambling/Daily', text: 'Daily', count: 0},
                {name: 'Frequency of Gambling/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optGamblinglocationspast12months = [
                {name: 'Gambling locations during the past 12 months/None', text: 'None', count: 0},
                {name: 'Gambling locations during the past 12 months/Casino', text: 'Casino', count: 0},
                {name: 'Gambling locations during the past 12 months/Race track', text: 'Race track', count: 0},
                {name: 'Gambling locations during the past 12 months/Grocery/Convenience Store', text: 'Grocery/Convenience Store', count: 0},
                {name: 'Gambling locations during the past 12 months/Internet', text: 'Internet', count: 0},
                {name: 'Gambling locations during the past 12 months/Off-Track Betting (OTB)', text: 'Off-Track Betting (OTB)', count: 0},
                {name: 'Gambling locations during the past 12 months/Bookie', text: 'Bookie', count: 0},
                {name: 'Gambling locations during the past 12 months/Bar/Restaurant', text: 'Bar/Restaurant', count: 0},
                {name: 'Gambling locations during the past 12 months/Work', text: 'Work', count: 0},
                {name: 'Gambling locations during the past 12 months/School', text: 'School', count: 0},
                {name: 'Gambling locations during the past 12 months/Home', text: 'Home', count: 0},
                {name: 'Gambling locations during the past 12 months/Church', text: 'Church', count: 0},
                {name: 'Gambling locations during the past 12 months/Community Site', text: 'Community Site', count: 0},
                {name: 'Gambling locations during the past 12 months/Other', text: 'Other', count: 0},
                {name: 'Gambling locations during the past 12 months/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]
            this.optHasClientAttendedReceivedServices = [
                {name: 'Has client attended or received services for any reason from/Self-Help', text: 'Self-Help', count: 0},
                {name: 'Has client attended or received services for any reason from/Other Gambling Program', text: 'Other Gambling Program', count: 0},
                {name: 'Has client attended or received services for any reason from/Financial and/or Credit Counseling Service', text: 'Financial and/or Credit Counseling Service', count: 0},
                {name: 'Has client attended or received services for any reason from/N/A', text: 'N/A', count: 0},
                {name: 'Has client attended or received services for any reason from/Prefer not to answer', text: 'Prefer not to answer', count: 0},
            ]

            val.arregloFiltrado.forEach(dataClientActivity => {
                    if(dataClientActivity.dateOfAdmission && dataClientActivity.newOrReturningClient && dataClientActivity.presentingProblemsAtAdmission && dataClientActivity.diagnosticCriteriaMetAtAdmission) {
                        test3 += 1
                    }
                    if(dataClientActivity.statusLogical === 'Admitted') {
                        test += 1
                    } 
                    else if(dataClientActivity.statusLogical === 'Discharged') {
                        test1 += 1
                    }
                    else {
                        test2 += 1
                    }
                    
                    if(dataClientActivity.dateOfAdmission) {
                        this.countTotalClientsInTreatment += 1
                        // if(dataClientActivity.dischargeStatus === 'Planned') {
                            // Total Clients In Treatment
                            // this.countTotalClientsInTreatment += 1

                            if(dataClientActivity.contactStatus) {
                                // Total Family Members In Treatment
                                if(dataClientActivity.contactStatus === 'Family Member') {
                                    this.countTotalFamilyMembersInTreatment += 1
                                }

                                // Total Gamblers In Treatment
                                if(dataClientActivity.contactStatus === 'Problem Gambler') {
                                    this.countTotalGamblersInTreatment += 1
                                }

                                // Total Gamblers Other
                                if(dataClientActivity.contactStatus !== 'Family Member' && dataClientActivity.contactStatus !== 'Problem Gambler') {
                                    other += 1
                                    this.countOtherBlank += 1
                                }
                            } else {
                                other += 1
                                this.countOtherBlank += 1
                            }

                            if(dataClientActivity.dateOfDischarge && dataClientActivity.dateOfDischarge !== 'N/A') {
                                // diff dataClientActivity.data().dateOfDischarge - dataClientActivity.data().dateOfAdmission
                                this.averageLengthOfStay = 6
                            }

                            // total non-english
                            if(dataClientActivity.language !== 'English') {
                                this.totalNonEnglishClients += 1
                                this.loadTotalClients = false
                            }
                        // }
                    }
                
                if(dataClientActivity.newOrReturningClient) {
                    if(dataClientActivity.newOrReturningClient === 'New Client') {
                        this.countNewClient += 1
                    }

                    if(dataClientActivity.newOrReturningClient === 'Returning Client') {
                        this.countReturningClient += 1
                    }
                }

                if(dataClientActivity.presentingProblemsAtAdmission) {
                    if(dataClientActivity.presentingProblemsAtAdmission === 'Co-occurring mental health disorders' || dataClientActivity.presentingProblemsAtAdmission.includes('Co-occurring mental health disorders')) {
                        this.countPPAACOMHD += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Co-occurring substance use disorders' || dataClientActivity.presentingProblemsAtAdmission.includes('Co-occurring substance use disorders')) {
                        this.countPPAACOSUD += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Employment difficulties' || dataClientActivity.presentingProblemsAtAdmission.includes('Employment difficulties')) {
                        this.countPPAAED += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Financial difficulties' || dataClientActivity.presentingProblemsAtAdmission.includes('Financial difficulties')) {
                        this.countPPAAFD += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Physical health problems' || dataClientActivity.presentingProblemsAtAdmission.includes('Physical health problems')) {
                        this.countPPAAPHP += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Relationship difficulties' || dataClientActivity.presentingProblemsAtAdmission.includes('Relationship difficulties')) {
                        this.countPPAARD += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Education difficulties' || dataClientActivity.presentingProblemsAtAdmission.includes('Education difficulties')) {
                        this.countPPAAED += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Marital difficulties' || dataClientActivity.presentingProblemsAtAdmission.includes('Marital difficulties')) {
                        this.countPPAAMD += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Bankruptcy' || dataClientActivity.presentingProblemsAtAdmission.includes('Bankruptcy')) {
                        this.countPPAAB += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Borrowing or theft from family/friends' || dataClientActivity.presentingProblemsAtAdmission.includes('Borrowing or theft from family/friends')) {
                        this.countPPAABOTFFF += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Losing savings/retirement' || dataClientActivity.presentingProblemsAtAdmission.includes('Losing savings/retirement')) {
                        this.countPPAALSR += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Significant debt' || dataClientActivity.presentingProblemsAtAdmission.includes('Significant debt')) {
                        this.countPPAASD += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Embezzlement' || dataClientActivity.presentingProblemsAtAdmission.includes('Embezzlement')) {
                        this.countPPAAE += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Suicidal Ideation/Thoughts/Attempts' || dataClientActivity.presentingProblemsAtAdmission.includes('Suicidal Ideation/Thoughts/Attempts')) {
                        this.countPPAASITA += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Legal Issues' || dataClientActivity.presentingProblemsAtAdmission.includes('Legal Issues')) {
                        this.countPPAALI += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Arrest' || dataClientActivity.presentingProblemsAtAdmission.includes('Arrest')) {
                        this.countPPAAA += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'Incarceration' || dataClientActivity.presentingProblemsAtAdmission.includes('Incarceration')) {
                        this.countPPAAINCA += 1
                    }

                    if(dataClientActivity.presentingProblemsAtAdmission === 'N/A' || dataClientActivity.presentingProblemsAtAdmission.includes('N/A')) {
                        this.countPPAANA += 1
                    }
                }

                if(dataClientActivity.diagnosticCriteriaMetAtAdmission) {
                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'N/A' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('N/A')) {
                        this.countDCMAANA += 1
                    }

                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'After losing money gambling, often returns another day to get even ("chasing" ones losses)' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('After losing money gambling, often returns another day to get even ("chasing" ones losses)')) {
                        this.countDCMAAALMGOR += 1
                    }
                    
                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'Has jeopardized or lost a significant relationship, job, or educational or career opportunity because of gambling.' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('Has jeopardized or lost a significant relationship, job, or educational or career opportunity because of gambling.')) {
                        this.countDCMAAHJLASR += 1
                    }

                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'Has made repeated unsuccesful efforts to control, cut back, or stop gambling' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('Has made repeated unsuccesful efforts to control, cut back, or stop gambling')) {
                        this.countDCMAAHMRUETC += 1
                    }

                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'Is often preoccupied with (e.g., having persistent thoughts of reliving past gambling experiences, handicapping or planning the next venture, thinking of ways to get money with which to gamble).' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('Is often preoccupied with (e.g., having persistent thoughts of reliving past gambling experiences, handicapping or planning the next venture, thinking of ways to get money with which to gamble).')) {
                        this.countDCMAAIOPW += 1
                    }

                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'Is restless or irritable when attempting to cut down or stop gambling.' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('Is restless or irritable when attempting to cut down or stop gambling.')) {
                        this.countDCMAAIROIWA += 1
                    }

                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'Lies to conceal the extent of involvement with gambling.' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('Lies to conceal the extent of involvement with gambling.')) {
                        this.countDCMAALTCTE += 1
                    }

                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'Often gambles when feeling distressed (e.g., helpless, guilty, anxious, depressed).' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('Often gambles when feeling distressed (e.g., helpless, guilty, anxious, depressed).')) {
                        this.countDCMAAOGWFD += 1
                    }

                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'Needs to gamble with increasing amounts of money in order to achieve the desired excitement.' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('Needs to gamble with increasing amounts of money in order to achieve the desired excitement.')) {
                        this.countDCMAANTGWI += 1
                    }

                    if(dataClientActivity.diagnosticCriteriaMetAtAdmission === 'Relies on others to provide money to relieve desperate financial situations caused by gambling.' || dataClientActivity.diagnosticCriteriaMetAtAdmission.includes('Relies on others to provide money to relieve desperate financial situations caused by gambling.')) {
                        this.countDCMAAROOTPM += 1
                    }
                }

                if(dataClientActivity.clientInvolvedWithLegalSystem) {
                    if(dataClientActivity.clientInvolvedWithLegalSystem === 'Yes' || dataClientActivity.clientInvolvedWithLegalSystem.includes('Yes')) {
                        this.countCIWLSYES += 1
                    }

                    if(dataClientActivity.clientInvolvedWithLegalSystem === 'No' || dataClientActivity.clientInvolvedWithLegalSystem.includes('No')) {
                        this.countCIWLSNO += 1
                    }

                    if(dataClientActivity.clientInvolvedWithLegalSystem === 'N/A' || dataClientActivity.clientInvolvedWithLegalSystem.includes('N/A')) {
                        this.countCIWLSNA += 1
                    }
                }

                if(dataClientActivity.clientReleaseSigned) {
                    if(dataClientActivity.clientReleaseSigned === 'Yes' || dataClientActivity.clientReleaseSigned.includes('Yes')) {
                        this.countCRSYES += 1
                    }

                    if(dataClientActivity.clientReleaseSigned === 'No' || dataClientActivity.clientReleaseSigned.includes('No')) {
                        this.countCRSNO += 1
                    }

                    if(dataClientActivity.clientReleaseSigned === 'N/A' || dataClientActivity.clientReleaseSigned.includes('N/A')) {
                        this.countCRSNA += 1
                    }
                }

                if(dataClientActivity.race) {
                    if(dataClientActivity.race === 'Alaskan Native' || dataClientActivity.clientReleaseSigned.includes('Alaskan Native')) {
                        this.countRaceAN += 1
                    }

                    if(dataClientActivity.race === 'Asian' || dataClientActivity.clientReleaseSigned.includes('Asian')) {
                        this.countRaceAs += 1
                    }

                    if(dataClientActivity.race === 'Black or African American' || dataClientActivity.clientReleaseSigned.includes('Black or African American')) {
                        this.countRaceBOAA += 1
                    }

                    if(dataClientActivity.race === 'Hawaiian or other Pacific Islander' || dataClientActivity.clientReleaseSigned.includes('Hawaiian or other Pacific Islander')) {
                        this.countRaceHOOOPI += 1
                    }

                    if(dataClientActivity.race === 'Middle Eastern or North African' || dataClientActivity.clientReleaseSigned.includes('Middle Eastern or North African')) {
                        this.countRaceMEONA += 1
                    }

                    if(dataClientActivity.race === 'Native American, Indigenous, or American Indian' || dataClientActivity.clientReleaseSigned.includes('Native American, Indigenous, or American Indian')) {
                        this.countRaceNAIOAI += 1
                    }

                    if(dataClientActivity.race === 'White' || dataClientActivity.clientReleaseSigned.includes('White')) {
                        this.countRaceWH += 1
                    }

                    if(dataClientActivity.race === 'Some other race, ethnicity, origin' || dataClientActivity.clientReleaseSigned.includes('Some other race, ethnicity, origin')) {
                        this.countRaceSOREO += 1
                    }

                    if(dataClientActivity.race === 'Prefer not to answer' || dataClientActivity.clientReleaseSigned.includes('Prefer not to answer')) {
                        this.countRacePNTA += 1
                    }
                }

                if(dataClientActivity.ethnicity) {
                    if(dataClientActivity.ethnicity === 'Cuban' || dataClientActivity.ethnicity.includes('Cuban')) {
                        this.countEthnicityCUB += 1
                    }

                    if(dataClientActivity.ethnicity === 'Mexican' || dataClientActivity.ethnicity.includes('Mexican')) {
                        this.countEthnicityMEX += 1
                    }

                    if(dataClientActivity.ethnicity === 'Puerto Rican' || dataClientActivity.ethnicity.includes('Puerto Rican')) {
                        this.countEthnicityPR += 1
                    }

                    if(dataClientActivity.ethnicity === 'Hispanic/Latino/a/x, Not Specified' || dataClientActivity.ethnicity.includes('Hispanic/Latino/a/x, Not Specified')) {
                        this.countEthnicityHLNS += 1
                    }

                    if(dataClientActivity.ethnicity === 'Not of Hispanic Origin' || dataClientActivity.ethnicity.includes('Not of Hispanic Origin')) {
                        this.countEthnicityNOTH += 1
                    }

                    if(dataClientActivity.ethnicity === 'Prefer not to answer' || dataClientActivity.ethnicity.includes('Prefer not to answer')) {
                        this.countEthnicityPNTA += 1
                    }
                }

                if(dataClientActivity.asianOrigin) {
                    if(dataClientActivity.asianOrigin === 'Asian Indian' || dataClientActivity.asianOrigin.includes('Asian Indian')) {
                        this.countAsianAIN += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Bangladeshi' || dataClientActivity.asianOrigin.includes('Bangladeshi')) {
                        this.countAsianBANG += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Burmese' || dataClientActivity.asianOrigin.includes('Burmese')) {
                        this.countAsianBURM += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Cambodian' || dataClientActivity.asianOrigin.includes('Cambodian')) {
                        this.countAsianCAMB += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Chinese' || dataClientActivity.asianOrigin.includes('Chinese')) {
                        this.countAsianCHIN += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Filipino' || dataClientActivity.asianOrigin.includes('Filipino')) {
                        this.countAsianFIL += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Hmong' || dataClientActivity.asianOrigin.includes('Hmong')) {
                        this.countAsianHMONG += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Indonesian' || dataClientActivity.asianOrigin.includes('Indonesian')) {
                        this.countAsianINDO += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Japanese' || dataClientActivity.asianOrigin.includes('Japanese')) {
                        this.countAsianJAP += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Korean' || dataClientActivity.asianOrigin.includes('Korean')) {
                        this.countAsianKOR += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Laotian' || dataClientActivity.asianOrigin.includes('Laotian')) {
                        this.countAsianLAOT += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Malaysian' || dataClientActivity.asianOrigin.includes('Malaysian')) {
                        this.countAsianMALA += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Nepalese' || dataClientActivity.asianOrigin.includes('Nepalese')) {
                        this.countAsianNEPA += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Pakistani' || dataClientActivity.asianOrigin.includes('Pakistani')) {
                        this.countAsianPAKI += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Sri Lankan' || dataClientActivity.asianOrigin.includes('Sri Lankan')) {
                        this.countAsianSRI += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Taiwanese' || dataClientActivity.asianOrigin.includes('Taiwanese')) {
                        this.countAsianTAIW += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Thai' || dataClientActivity.asianOrigin.includes('Thai')) {
                        this.countAsianTHAI += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Tibetan' || dataClientActivity.asianOrigin.includes('Tibetan')) {
                        this.countAsianTIB += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Vietnamese' || dataClientActivity.asianOrigin.includes('Vietnamese')) {
                        this.countAsianVIET += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Asian, Not Specified' || dataClientActivity.asianOrigin.includes('Asian, Not Specified')) {
                        this.countAsianNSPE += 1
                    }
                    
                    if(dataClientActivity.asianOrigin === 'Not of Asian Origin' || dataClientActivity.asianOrigin.includes('Not of Asian Origin')) {
                        this.countAsianNAORI += 1
                    }

                    if(dataClientActivity.asianOrigin === 'Prefer not to answer' || dataClientActivity.asianOrigin.includes('Prefer not to answer')) {
                        this.countAsianPNTA += 1
                    }
                }

                if(dataClientActivity.pacificIslanderOrigin) {
                    var filter = this.optPacificIslanderOrigin.filter(ele => ele.text === dataClientActivity.pacificIslanderOrigin || dataClientActivity.pacificIslanderOrigin.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.householdIncome) {
                    var filter = this.optHouseholdIncome.filter(ele => ele.text === dataClientActivity.householdIncome || dataClientActivity.householdIncome.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.gamblingTypes) {
                    var filter = this.optGamblingTypes.filter(ele => ele.text === dataClientActivity.gamblingTypes || dataClientActivity.gamblingTypes.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.employmentStatus) {
                    var filter = this.optEmploymentStatus.filter(ele => ele.text === dataClientActivity.employmentStatus || dataClientActivity.employmentStatus.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.educationLevels) {
                    var filter = this.optEducationLevels.filter(ele => ele.text === dataClientActivity.educationLevels || dataClientActivity.educationLevels.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }
                
                if(dataClientActivity.veteran) {
                    var filter = this.optVeteran.filter(ele => ele.text === dataClientActivity.veteran || dataClientActivity.veteran.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.industryOfEmployment) {
                    var filter = this.optIndustryOfEmployment.filter(ele => ele.text === dataClientActivity.industryOfEmployment || dataClientActivity.industryOfEmployment.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.maritalStatus) {
                    var filter = this.optMaritalStatus.filter(ele => ele.text === dataClientActivity.maritalStatus || dataClientActivity.maritalStatus.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.religiousPreference) {
                    var filter = this.optReligiousPreference.filter(ele => ele.text === dataClientActivity.religiousPreference || dataClientActivity.religiousPreference.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }
                
                if(dataClientActivity.primaryICD10) {
                    var filter = this.optPrimaryICD10.filter(ele => ele.text === dataClientActivity.primaryICD10 || dataClientActivity.primaryICD10.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.age) {
                    var filter = this.optAge.filter(ele => ele.text === dataClientActivity.age || dataClientActivity.age.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.sexualOrientation) {
                    var filter = this.optSexualOrientation.filter(ele => ele.text === dataClientActivity.sexualOrientation || dataClientActivity.sexualOrientation.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.genderIdentity) {
                    var filter = this.optGenderIdentity.filter(ele => ele.text === dataClientActivity.genderIdentity || dataClientActivity.genderIdentity.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.transgender) {
                    var filter = this.optTransgender.filter(ele => ele.text === dataClientActivity.transgender || dataClientActivity.transgender.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.referredByAdmission) {
                    var filter = this.optReferredBy.filter(ele => ele.text === dataClientActivity.referredByAdmission || dataClientActivity.referredByAdmission.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.developmentalDisability) {
                    var filter = this.optIDisabilityDevelopmentalDisability.filter(ele => ele.text === dataClientActivity.developmentalDisability || dataClientActivity.developmentalDisability.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.coexistingPsychiatricDisorder) {
                    var filter = this.optPsychiatricDisorder.filter(ele => ele.text === dataClientActivity.coexistingPsychiatricDisorder || dataClientActivity.coexistingPsychiatricDisorder.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.treatedForMentalIllness) {
                    var filter = this.optMentalIllness.filter(ele => ele.text === dataClientActivity.treatedForMentalIllness || dataClientActivity.treatedForMentalIllness.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.hospitalizedForMentalIllness) {
                    var filter = this.optHospitalizedforMentalIllness.filter(ele => ele.text === dataClientActivity.hospitalizedForMentalIllness || dataClientActivity.hospitalizedForMentalIllness.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.hospitalized30OrMoreDaysForMentalIllness) {
                    var filter = this.optHospitalized30ormoredays.filter(ele => ele.text === dataClientActivity.hospitalized30OrMoreDaysForMentalIllness || dataClientActivity.hospitalized30OrMoreDaysForMentalIllness.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.smokedTobaccoInThePastWeek) {
                    var filter = this.optSmokedtobacco.filter(ele => ele.text === dataClientActivity.smokedTobaccoInThePastWeek || dataClientActivity.smokedTobaccoInThePastWeek.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.usedSmokelessTobaccoInThePastWeek) {
                    var filter = this.optUsedsmokelesstobacco.filter(ele => ele.text === dataClientActivity.usedSmokelessTobaccoInThePastWeek || dataClientActivity.usedSmokelessTobaccoInThePastWeek.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.substancesUsed) {
                    var filter = this.optSubstancesUsed.filter(ele => ele.text === dataClientActivity.substancesUsed || dataClientActivity.substancesUsed.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.substanceUseRouteOfAdministration) {
                    var filter = this.optSubstanceUseRouteOfAdministration.filter(ele => ele.text === dataClientActivity.substanceUseRouteOfAdministration || dataClientActivity.substanceUseRouteOfAdministration.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.frequencyOfSubstanceUse) {
                    var filter = this.optFrequencyOfSubstanceUse.filter(ele => ele.text === dataClientActivity.frequencyOfSubstanceUse || dataClientActivity.frequencyOfSubstanceUse.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.frequencyofGambling) {
                    var filter = this.optFrequencyofGambling.filter(ele => ele.text === dataClientActivity.frequencyofGambling || dataClientActivity.frequencyofGambling.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.gamblinglocationspast12months) {
                    var filter = this.optGamblinglocationspast12months.filter(ele => ele.text === dataClientActivity.gamblinglocationspast12months || dataClientActivity.gamblinglocationspast12months.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                if(dataClientActivity.hasClientAttendedReceivedServices) {
                    var filter = this.optHasClientAttendedReceivedServices.filter(ele => ele.text === dataClientActivity.hasClientAttendedReceivedServices || dataClientActivity.hasClientAttendedReceivedServices.includes(ele.text))
                    if(filter.length) {
                        filter[0].count += 1
                    }
                }

                arrayExport.push({
                    // clientID: dataClientActivity.,
                    // clientName: dataClientActivity.,
                    status: dataClientActivity.statusLogical,
                    // statusLogical: dataClientActivity.,
                    contactDate: dataClientActivity.contactDate,
                    // contactDateFormat: dataClientActivity.,
                    // formatAdmission: dataClientActivity.dateOfAdmission ? moment(dataClientActivity.dateOfAdmission,'MM/DD/YYYY').format('DD/MM/YYYY') : '',
                    dateOfAdmission: dataClientActivity.dateOfAdmission,
                    // dateOfAdmissionFormat: dataClientActivity.,
                    // formatDischarge: dataClientActivity.dateOfDischarge ? moment(dataClientActivity.dateOfDischarge,'MM/DD/YYYY').format('DD/MM/YYYY') : '',
                    dateOfDischarge: dataClientActivity.dateOfDischarge,
                    // dateOfDischargeFormat: dataClientActivity.,
                    contactStatus: dataClientActivity.contactStatus,
                    enterAdmissionDischargeInformation: dataClientActivity.enterAdmissionDischargeInformation,
                    newOrReturningClient: dataClientActivity.newOrReturningClient,
                    presentingProblemsAtAdmission: dataClientActivity.presentingProblemsAtAdmission,
                    diagnosticCriteriaMetAtAdmission: dataClientActivity.diagnosticCriteriaMetAtAdmission,
                    clientInvolvedWithLegalSystem: dataClientActivity.clientInvolvedWithLegalSystem,
                    clientReleaseSigned: dataClientActivity.clientReleaseSigned,
                    initialAppointmentDate: dataClientActivity.initialAppointmentDate ? moment(dataClientActivity.initialAppointmentDate,'DD/MM/YYYY').format('MM/DD/YYYY') : '',
                    // created: dataClientActivity.,
                    // clinicianStatus: dataClientActivity.,
                    dischargeStatus: dataClientActivity.dischargeStatus,
                    region: dataClientActivity.region,
                    // insurance: dataClientActivity.,
                    clientStatusAdmission: dataClientActivity.clientStatusAdmission ? dataClientActivity.clientStatusAdmission : '',
                    primaryICD10: dataClientActivity.primaryICD10 ? dataClientActivity.primaryICD10 : '',
                    locadtrgCompleted: dataClientActivity.locadtrg ? dataClientActivity.locadtrg : '',
                    LOCADTRAssessmentID: dataClientActivity.LOCADTRAssessmentID ? dataClientActivity.LOCADTRAssessmentID : '',

                    // new fields
                    otherProblemsAdmission: dataClientActivity.otherProblemsAdmission ? dataClientActivity.otherProblemsAdmission : '',
                    race: dataClientActivity.race ? dataClientActivity.race : '',
                    householdIncome: dataClientActivity.householdIncome ? dataClientActivity.householdIncome : '',
                    gamblingTypes: dataClientActivity.gamblingTypes ? dataClientActivity.gamblingTypes : '',
                    employmentStatus: dataClientActivity.employmentStatus ? dataClientActivity.employmentStatus : '',
                    educationLevels: dataClientActivity.educationLevels ? dataClientActivity.educationLevels : '',
                    ethnicity: dataClientActivity.ethnicity ? dataClientActivity.ethnicity : '',
                    veteran: dataClientActivity.veteran ? dataClientActivity.veteran : '',
                    zipCode: dataClientActivity.zipCode ? dataClientActivity.zipCode : '',
                    industryOfEmployment: dataClientActivity.industryOfEmployment ? dataClientActivity.industryOfEmployment : '',
                    maritalStatus: dataClientActivity.maritalStatus ? dataClientActivity.maritalStatus : '',
                    religiousPreference: dataClientActivity.religiousPreference ? dataClientActivity.religiousPreference : '',

                    // client information
                    clientID: dataClientActivity.idClient ? dataClientActivity.idClient.replace(/#/g, "") : '',
                    insurance: dataClientActivity.insurance ? dataClientActivity.insurance : '',
                    county: dataClientActivity.county ? dataClientActivity.county : '',
                    language: dataClientActivity.language ? dataClientActivity.language : '',
                    // gender: dataClientActivity.gender ? dataClientActivity.gender : '',
                    program: dataClientActivity.clinicianProgram ? dataClientActivity.clinicianProgram : '',
                    clinicianName: dataClientActivity.acn ? dataClientActivity.acn : ''
                })
                // }
            })
            // console.log(other)

            // this.json_data = [
            //     {
            //         'Filter Start Date': this.startDate,
            //         'Filter End Date': this.endDate,
            //         'Filter Region': this.region,
            //         'Filter Borough': this.borough,
            //         'Total Clients In Treatment': this.countTotalClientsInTreatment.toString().replace(',', ''),
            //         'Total Family Members In Treatment': this.countTotalFamilyMembersInTreatment.toString().replace(',', ''),
            //         'Total Gamblers In Treatment': this.countTotalGamblersInTreatment.toString().replace(',', ''),
            //         'Total Non-English Clients': this.totalNonEnglishClients.toString().replace(',', '')
            //     }
            // ]

            // this.json_data = val.arregloFiltrado
            this.json_data = arrayExport
            this.readyToExport = true

            // if(test >= 100 && this.startDate && this.endDate) {
            //     this.countTotalClientsInTreatment = test
            // }
            // console.log(test, test1, test2, test3, val.count, val.county)

            // if(val.count > 0) {
            //     this.countTotalClientsInTreatment = val.count
            // }
            // this.isBusy = false
        },
        arrayFiltradoReportsActiveTreatmentClaims(val) {
            this.totalGroupSessions = 0
            this.totalIndividualSessions = 0
            this.totalRemoteSessions = 0

            this.improved = 0
            this.averageTreatmentSessionsCompleted = 0
            val.forEach(itemClaim => {
                if(itemClaim.approvalStatus === 'approved' || itemClaim.approvalStatus === 'paid') {
                    this.totalGroupSessions += parseInt(itemClaim.noGroupSessions, 10)
                    this.totalIndividualSessions += parseInt(itemClaim.noIndividualSessions, 10)
                    this.totalRemoteSessions += parseInt(itemClaim.noRemoteSessions, 10)
                }
                this.improved += 1
            })
            if(this.totalIndividualSessions === 0 && this.improved === 0) this.averageTreatmentSessionsCompleted = 0
            else this.averageTreatmentSessionsCompleted = (this.totalIndividualSessions / this.improved).toFixed(2)
        }
    },
    methods: {
        ...mapActions(['searchClientActivityName','searchClientActivityStatus','searchClientActivityClinicianName','searchReportsActiveTreatmentRegion','searchReportsActiveTreatmentProgress','searchReportsActiveTreatmentLanguage','searchReportsActiveTreatmentInsurance','searchClientActivityClinicianStatus','searchClientActivityClientID','searchReportsActiveTreatmentStartDate','searchReportsActiveTreatmentEndDate','setSnapshotClientActivityReportsActiveTreatment','setSnapshotClientClaimReportsActiveTreatment','searchReportsActiveTreatmentProgram','searchReportsActiveTreatmentnewOrReturningClient','searchReportsActiveTreatmentclientStatusAdmission','searchReportsActiveTreatmentpresentingProblemsAtAdmission','searchReportsActiveTreatmentdiagnosticCriteriaMetAtAdmission','searchReportsActiveTreatmentclientInvolvedWithLegalSystem','searchReportsActiveTreatmentclientReleaseSigned','searchReportsActiveTreatmentrace','searchReportsActiveTreatmentethnicity','searchReportsActiveTreatmentasianOrigin','searchReportsActiveTreatmentpacificIslanderOrigin','searchReportsActiveTreatmenthouseholdIncome','searchReportsActiveTreatmentgamblingTypes','searchReportsActiveTreatmentemploymentStatus','searchReportsActiveTreatmenteducationLevels','searchReportsActiveTreatmentveteran','searchReportsActiveTreatmentindustryOfEmployment','searchReportsActiveTreatmentmaritalStatus','searchReportsActiveTreatmentreligiousPreference','searchReportsActiveTreatmentprimaryICD10','searchReportsActiveTreatmentage','searchReportsActiveTreatmentsexualOrientation','searchReportsActiveTreatmentgenderIdentity','searchReportsActiveTreatmenttransgender','searchReportsActiveTreatmentreferredByAdmission','searchReportsActiveTreatmentdevelopmentalDisability','searchReportsActiveTreatmentcoexistingPsychiatricDisorder','searchReportsActiveTreatmenttreatedForMentalIllness','searchReportsActiveTreatmenthospitalizedForMentalIllness','searchReportsActiveTreatmenthospitalized30OrMoreDaysForMentalIllness','searchReportsActiveTreatmentsmokedTobaccoInThePastWeek','searchReportsActiveTreatmentusedSmokelessTobaccoInThePastWeek','searchReportsActiveTreatmentsubstancesUsed','searchReportsActiveTreatmentsubstanceUseRouteOfAdministration','searchReportsActiveTreatmentfrequencyOfSubstanceUse','searchReportsActiveTreatmentfrequencyofGambling','searchReportsActiveTreatmentgamblinglocationspast12months','searchReportsActiveTreatmenthasClientAttendedReceivedServices']),
        activeFilterFunction() {
            this.startDate = null
            this.endDate = null
            this.selectedRangeDate = 'month'
            this.region = ''
            this.borough = ''
            this.language = ''
            this.progress = ''
            this.insurance = ''
            this.clinicianProgram = null
            // this.functionFilters()
            this.activeFilters = false
        },
        functionDateRange(val) {
            if(val === 'month') {
                // console.log(this.startDate)
                if(this.startDate) {
                    // '24/03/2022'
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(this.startDate,this.endDate)
                }
            } else if(val === 'quarter') {
                if(this.startDate) {
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                }
            } else if(val === 'year') {
                if(this.startDate) {
                    var formatDateNew = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var getYear = moment(formatDateNew).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = '01/01/'+getYear
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,expiredDate,dateUpdateFormat)
                } else {
                    var getYear = moment(Date.now()).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = moment('01/01/'+getYear).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                    // console.log(formatDate,dateUpdateFormat)
                }
            } else if(val === 'x') {
                this.selectedRangeDate = ''
                this.startDate = null
                this.endDate = null
            }
        },
        prevRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).subtract(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        nextRange() {
            // console.log(this.startDate, this.selectedRangeDate)
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).add(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                console.log(dateUpdateFormat)

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        functionFilters() {
            if(this.clientActivityStatus) {
                this.searchClientActivityStatus(this.clientActivityStatus)
            } else {
                this.searchClientActivityStatus('')
            }

            if(this.startDate) {
                this.searchReportsActiveTreatmentStartDate(this.startDate)
            } else {
                this.searchReportsActiveTreatmentStartDate('')
            }

            if(this.endDate) {
                this.searchReportsActiveTreatmentEndDate(this.endDate)
            } else {
                this.searchReportsActiveTreatmentEndDate('')
            }

            if(this.region) {
                this.searchReportsActiveTreatmentRegion(this.region)
            } else {
                this.searchReportsActiveTreatmentRegion('')
            }

            if(this.progress) {
                this.searchReportsActiveTreatmentProgress(this.progress)
            } else {
                this.searchReportsActiveTreatmentProgress('')
            }

            if(this.language) {
                this.searchReportsActiveTreatmentLanguage(this.language)
            } else {
                this.searchReportsActiveTreatmentLanguage('')
            }

            if(this.insurance) {
                this.searchReportsActiveTreatmentInsurance(this.insurance)
            } else {
                this.searchReportsActiveTreatmentInsurance('')
            }
        }
    },
    created() {
        this.countOtherBlank = 0

        var user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(doc => {
            this.isDataSpecialist = false
            if(doc.data().role === 'staff') {
                if(doc.data().permissions.includes('data specialist')) {
                    this.isDataSpecialist = true
                }
            } else if(doc.data().role === 'admin') {
                this.isDataSpecialist = true
            }
        })
        
        this.startDate = this.searchReportsActiveTreatmentStartDateState ? this.searchReportsActiveTreatmentStartDateState : null
        this.endDate = this.searchReportsActiveTreatmentEndDateState ? this.searchReportsActiveTreatmentEndDateState : null
        this.region = this.searchReportsActiveTreatmentRegionState ? this.searchReportsActiveTreatmentRegionState : ''
        this.language = this.searchReportsActiveTreatmentProgressState ? this.searchReportsActiveTreatmentProgressState : ''
        this.progress = this.searchReportsActiveTreatmentLanguageState ? this.searchReportsActiveTreatmentLanguageState : ''
        this.insurance = this.searchReportsActiveTreatmentInsuranceState ? this.searchReportsActiveTreatmentInsuranceState : ''
        this.clinicianProgram = this.searchReportsActiveTreatmentProgramState ? this.searchReportsActiveTreatmentProgramState : null
        this.$http.get('https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/prod/active-treatment/reports')
        .then(res => {
            this.itemsActivity = []
            this.countTotalClientsInTreatment = res.data.counter.countTotalClientsInTreatment
            this.countTotalFamilyMembersInTreatment = res.data.counter.countTotalFamilyMembersInTreatment
            this.countTotalGamblersInTreatment = res.data.counter.countTotalGamblersInTreatment
            this.averageLengthOfStay = res.data.counter.averageLengthOfStay
            this.totalNonEnglishClients = res.data.counter.totalNonEnglishClients

            this.setSnapshotClientActivityReportsActiveTreatment(res.data.activity)
            this.isBusy = false
            this.loadTotalClients = false
        })

        // db.collection('clientsActivity').where('clientStatus', '==', 'active').get()
        // .then(docsClients => {
        //     this.itemsActivity = []
        //     this.countTotalClientsInTreatment = 0
        //     this.countTotalFamilyMembersInTreatment = 0
        //     this.countTotalGamblersInTreatment = 0
        //     this.averageLengthOfStay = 0
        //     this.totalNonEnglishClients = 0
        //     // var test = 0
        //     docsClients.forEach(dataClientActivity => {
        //         if(dataClientActivity.id !== 'counter') {
        //             // get data client
        //             var clientID = dataClientActivity.data().client
        //             var clientName = ''
        //             var language = ''
        //             var insurance = ''
        //             var statusClient = ''

        //             if(dataClientActivity.data().dateOfAdmission && dataClientActivity.data().newOrReturningClient && dataClientActivity.data().presentingProblemsAtAdmission && dataClientActivity.data().diagnosticCriteriaMetAtAdmission && dataClientActivity.data().clientInvolvedWithLegalSystem && dataClientActivity.data().clientReleaseSigned) {
        //                 // Total Clients In Treatment
        //                 this.countTotalClientsInTreatment += 1
        //             }
                    
        //             if(dataClientActivity.data().dateOfAdmission && dataClientActivity.data().newOrReturningClient && dataClientActivity.data().presentingProblemsAtAdmission && dataClientActivity.data().diagnosticCriteriaMetAtAdmission && dataClientActivity.data().clientInvolvedWithLegalSystem && dataClientActivity.data().clientReleaseSigned) {
        //                 // Total Clients In Treatment
        //                 // this.countTotalClientsInTreatment += 1

        //                 if(dataClientActivity.data().contactStatus) {
        //                     // Total Family Members In Treatment
        //                     if(dataClientActivity.data().contactStatus === 'Family Member') {
        //                         this.countTotalFamilyMembersInTreatment += 1
        //                     }

        //                     // Total Gamblers In Treatment
        //                     if(dataClientActivity.data().contactStatus === 'Problem Gambler') {
        //                         this.countTotalGamblersInTreatment += 1
        //                     }
        //                 }

        //                 if(dataClientActivity.data().dateOfDischarge) {
        //                     // diff dataClientActivity.data().dateOfDischarge - dataClientActivity.data().dateOfAdmission
        //                     this.averageLengthOfStay = 6
        //                 }

        //                 // total non-english
        //                 if(dataClientActivity.data().clientLang && dataClientActivity.data().clientLang !== 'English') {
        //                     this.totalNonEnglishClients += 1
        //                     this.loadTotalClients = false
        //                 }
        //             }

        //             var dateFormat = dataClientActivity.data().dateOfContact ? new Date(dataClientActivity.data().dateOfContact.split('-')) : ''
        //             var dateFormatAdmission = dataClientActivity.data().dateOfAdmission ? new Date(dataClientActivity.data().dateOfAdmission.split('-')) : ''
        //             var claimRegion = dataClientActivity.data().regionalCFEReceivingTheCall ? dataClientActivity.data().regionalCFEReceivingTheCall : ''

        //             var obj = {
        //                 clientID: clientID,
        //                 idClient: dataClientActivity.data().clientID ? dataClientActivity.data().clientID : '',
        //                 insurance: dataClientActivity.data().clientInsurance ? dataClientActivity.data().clientInsurance : '',
        //                 county: dataClientActivity.data().clientCounty ? dataClientActivity.data().clientCounty : '',
        //                 language: dataClientActivity.data().clientLang ? dataClientActivity.data().clientLang : '',
        //                 gender: dataClientActivity.data().clientGender ? dataClientActivity.data().clientGender : '',
        //                 clientName: clientName,
        //                 status: dataClientActivity.data().activityStatus,
        //                 statusLogical: dataClientActivity.data().activityStatusLogical ? dataClientActivity.data().activityStatusLogical : '',
        //                 contactDate: dataClientActivity.data().dateOfContact,
        //                 contactDateFormat: dateFormat ? moment(dateFormat,'DD/MM/YYYY').format('DD/MM/YYYY') : '',
        //                 dateOfAdmission: dataClientActivity.data().dateOfAdmission ? dataClientActivity.data().dateOfAdmission : '',
        //                 dateOfAdmissionFormat: dateFormatAdmission ? moment(dateFormatAdmission,'DD/MM/YYYY').format('DD/MM/YYYY') : '',
        //                 dateOfDischarge: dataClientActivity.data().dateOfDischarge ? dataClientActivity.data().dateOfDischarge : '',
        //                 dateOfDischargeFormat: dataClientActivity.data().dateOfDischarge ? moment(dataClientActivity.data().dateOfDischarge,'MM-DD-YYYY').format('DD/MM/YYYY') : '',
        //                 contactStatus: dataClientActivity.data().contactStatus,
        //                 enterAdmissionDischargeInformation: dataClientActivity.data().enterAdmissionDischargeInformation,
        //                 newOrReturningClient: dataClientActivity.data().newOrReturningClient,
        //                 presentingProblemsAtAdmission: dataClientActivity.data().presentingProblemsAtAdmission,
        //                 diagnosticCriteriaMetAtAdmission: dataClientActivity.data().diagnosticCriteriaMetAtAdmission,
        //                 clientInvolvedWithLegalSystem: dataClientActivity.data().clientInvolvedWithLegalSystem,
        //                 clientReleaseSigned: dataClientActivity.data().clientReleaseSigned,
        //                 initialAppointmentDate: dataClientActivity.data().initialAppointmentDate ? moment(dataClientActivity.data().initialAppointmentDate,'MM-DD-YYYY').format('DD/MM/YYYY') : '',
        //                 created: dataClientActivity.data().created ? moment(dataClientActivity.data().created,'MM-DD-YYYY').format('DD/MM/YYYY') : '',
        //                 clinicianStatus: dataClientActivity.data().clinicianStatus ? dataClientActivity.data().clinicianStatus : '',
        //                 dischargeStatus: dataClientActivity.data().dischargeStatus ? dataClientActivity.data().dischargeStatus : '',

        //                 region: dataClientActivity.data().regionalCFEReceivingTheCall ? dataClientActivity.data().regionalCFEReceivingTheCall : '',
        //                 borough: dataClientActivity.data().borough && claimRegion === 'NYC' ? dataClientActivity.data().borough : '',
        //                 clinicianProgram: dataClientActivity.data().clinicianProgram ? dataClientActivity.data().clinicianProgram : '',
        //                 arrayClinicianProgram: dataClientActivity.data().arrayClinicianProgram ? dataClientActivity.data().arrayClinicianProgram : ''
        //             }
        //             this.itemsActivity.push(obj)
        //         }
        //     })
        //     this.setSnapshotClientActivityReportsActiveTreatment(this.itemsActivity)
        //     this.isBusy = false
        // })

        db.collection('taxonomies').doc('client').get()
        .then(docTaxonomia => {
            // profile fields
            this.optionsLanguage = docTaxonomia.data().primaryLanguage
            this.optionsInsurance = docTaxonomia.data().insuranceType

            // new
            this.optionsRace = docTaxonomia.data().race
            this.optionsHouseholdIncome = docTaxonomia.data().householdIncome
            this.optionsGamblingTypes = docTaxonomia.data().gamblingTypes
            this.optionsEmploymentStatus = docTaxonomia.data().employmentStatus
            this.optionsEducationLevels = docTaxonomia.data().educationLevels
        })

        // db.collection('taxonomies').doc('client').get()
        // .then(docTaxonomia => {
        //     this.optionsRace = docTaxonomia.data().race
        //     this.optionsHouseholdIncome = docTaxonomia.data().householdIncome
        //     this.optionsGamblingTypes = docTaxonomia.data().gamblingTypes
        //     this.optionsEmploymentStatus = docTaxonomia.data().employmentStatus
        //     this.optionsEducationLevels = docTaxonomia.data().educationLevels
        //     this.optionsReferralOptions = docTaxonomia.data().referralOptions
        //     this.optionsRecoverySupportServices = docTaxonomia.data().recoverySupportServices
            
        //     this.optionsPaymentArrangement = docTaxonomia.data().paymentArrangement && docTaxonomia.data().paymentArrangement.length ? docTaxonomia.data().paymentArrangement : []
        //     var AtomConditionsPArrangement = docTaxonomia.data().conditionsPArrangement && docTaxonomia.data().conditionsPArrangement.length ? docTaxonomia.data().conditionsPArrangement : []
        //     AtomConditionsPArrangement.forEach(ele => {
        //         if(ele.cond && ele.label) {
        //             this.conditionsPArrangement.push(ele)
        //         }
        //     })
        // })

        db.collection('taxonomies').doc('clinician').get()
        .then(docTaxonomia => {
            // profile fields
            this.optionsRegion = docTaxonomia.data().region

            var arrayProgram = [{value: null, text: 'Any Program'}]
            docTaxonomia.data().program.forEach(item => {
                if(item !== 'OASAS') {
                    arrayProgram.push({value: item, text: item})
                }
            })
            this.optionsProgram = arrayProgram
        })
    }
}
</script>

<style>
.mx-input {
    height: 37px !important;
}
.form-control {
    background: #fff !important;
    background-color: #fff !important;
}
.range-date {
    padding: 8px;
    margin-top: 27px;
}
.vs__dropdown-option {
  white-space: normal !important;
}
.vs__dropdown-toggle {
  max-height: 38px;
}
.vs__selected-options {
  overflow: auto;
}
.vs__selected-options {
    overflow-x: hidden;
    overflow-y: hidden;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>